webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(32);




var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://rocky-savannah-28401.herokuapp.com/api/v1',
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use(function (config) {
  var token = localStorage.getItem("sts_token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

api.interceptors.response.use(function (response) {
  var newToken = response.headers["authorization"];
  if (newToken) {
    var token = newToken.split(" ")[1];
    if (token) {
      localStorage.setItem("sts_token", token);
    }
  }
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch("logout");
    if (window.location.pathname === "/viewpicks") {
      window.location.href = "/packages/all";
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = api;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(6);





var TestimonialRepository = function () {
  function TestimonialRepository() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TestimonialRepository);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TestimonialRepository, [{
    key: "getTestimonials",
    value: function getTestimonials(count) {
      var url = count ? "/testimonials?count=" + count : "/testimonials";
      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].get(url).then(function (response) {
        if (count) return response.data[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data)[0]];else return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: "get",
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].get("/testimonials/" + id).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: "create",
    value: function create(test) {
      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].post("/testimonials", test).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "update",
    value: function update(test) {
      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].put("/testimonials/" + test.id, test).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(test) {
      if (!test.id) return this.create(test);else return this.update(test);
    }
  }, {
    key: "remove",
    value: function remove(test) {
      return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].delete("/testimonials/" + test.id);
    }
  }]);

  return TestimonialRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new TestimonialRepository();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-24e98352",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var AuthRepository = function () {
  function AuthRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AuthRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AuthRepository, [{
    key: 'register',
    value: function register(data) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users', data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'login',
    value: function login(email, pw) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users/signin', {
        email: email,
        password: pw
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get',
    value: function get(token) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users?token=' + token).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'count',
    value: function count() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users/count').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(user) {
      var token = localStorage.getItem('sts_token');
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users/' + user.id, user, {
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(obj) {
      var token = localStorage.getItem('sts_token');
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/changePassword/' + obj.id, obj, {
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(email) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/users/resetpassword', { email: email }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return AuthRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new AuthRepository();

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var ProductRepository = function () {
  function ProductRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProductRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProductRepository, [{
    key: 'getAll',
    value: function getAll() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/products').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getBySlug',
    value: function getBySlug(slug) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/products/' + slug).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'createOrder',
    value: function createOrder(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/product-orders/create', data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'captureOrder',
    value: function captureOrder(orderId) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/' + orderId + '/capture').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getUserOrders',
    value: function getUserOrders() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/user').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getOrder',
    value: function getOrder(orderId) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/' + orderId).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ProductRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new ProductRepository();

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(270);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });


var _odds;








__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var cart = [];
try {
  var storedCart = localStorage.getItem("sts_cart");
  if (storedCart) {
    cart = JSON.parse(storedCart);
  }
} catch (err) {
  console.error("Error loading cart from localStorage:", err);
}

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: false,
  state: {
    currentUser: {},
    currentPackage: {},
    isAuthenticated: false,
    sports: [],
    packages: [],
    categories: [],
    picks: [],
    editUser: {},
    selectedSport: "mlb",
    odds: (_odds = {
      mlb: { live: {}, upcoming: {}, recent: {} },
      nba: { live: {}, upcoming: {}, recent: {} },
      ncaab: { live: {}, upcoming: {}, recent: {} }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_odds, "nba", { live: {}, upcoming: {}, recent: {} }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_odds, "nfl", { live: {}, upcoming: {}, recent: {} }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_odds, "mma", { live: {}, upcoming: {}, recent: {} }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_odds, "ncaaf", { live: {}, upcoming: {}, recent: {} }), _odds),

    products: [],
    currentProduct: null,
    cart: cart
  },
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var PickRepository = function () {
  function PickRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PickRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PickRepository, [{
    key: "getFreePicks",
    value: function getFreePicks() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/picks").then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: "createPick",
    value: function createPick(pick) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/picks", pick).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "updatePick",
    value: function updatePick(pick) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put("/picks/" + pick.id, pick).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(pick) {
      if (!pick.id) return this.createPick(pick);else return this.updatePick(pick);
    }
  }, {
    key: "getPick",
    value: function getPick(id) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/picks/" + id).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/picks?all=true").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getPremium",
    value: function getPremium() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/premium").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "remove",
    value: function remove(pick) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].delete("/picks/" + pick.id);
    }
  }]);

  return PickRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new PickRepository();

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var PostRepository = function () {
  function PostRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PostRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PostRepository, [{
    key: "get",
    value: function get(page, category, month, year) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/posts", {
        params: {
          page: page,
          category: category,
          month: month,
          year: year
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "recent",
    value: function recent() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/recentposts").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "archives",
    value: function archives() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/archives").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "create",
    value: function create(post) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/posts", post).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "update",
    value: function update(post) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put("/posts/" + post.id, post).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(post) {
      if (!post.id) return this.create(post);else return this.update(post);
    }
  }, {
    key: "getOne",
    value: function getOne(id) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/posts/" + id).then(function (response) {
        return response.data;
      });
    }
  }]);

  return PostRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new PostRepository();

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  "data-v-52c08b8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var CategoryRepository = function () {
  function CategoryRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CategoryRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CategoryRepository, [{
    key: "get",
    value: function get(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/categories").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "one",
    value: function one(id) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/categories/" + id).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "create",
    value: function create(cat) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/categories", cat).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "update",
    value: function update(cat) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put("/categories/" + cat.id, cat).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(cat) {
      if (!cat.id) return this.create(cat);else return this.update(cat);
    }
  }]);

  return CategoryRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new CategoryRepository();

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  "data-v-9eb82102",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MIN_PASSWORD_LENGTH; });
var PACKAGES = {
  ALL_ONE: "ALL1",
  ALL_TWO: "ALL2",
  ALL_MONTH: "ALLMO",
  ALL_YEAR: "ALLYR",

  MLB_ONE: "MLB1",
  MLB_MONTH: "MLBMO",
  MLB_FULL: "MLBFULL",

  NFL_ONE: "NFL1",
  NFL_MONTH: "NFLMO",
  NFL_FULL: "NFLFULL",

  NCAAF_ONE: "NCAAF1",
  NCAAF_MONTH: "NCAAFMO",
  NCAAF_FULL: "NCAAFFULL",

  NHL_ONE: "NHL1",
  NHL_MONTH: "NHLMO",
  NHL_FULL: "NHLFULL",

  NBA_ONE: "NBA1",
  NBA_MONTH: "NBAMO",
  NBA_FULL: "NBAFULL",

  NCAAB_ONE: "NCAAB1",
  NCAAB_MONTH: "NCAABMO",
  NCAAB_FULL: "NCAABFULL",

  MMA_ONE: "MMA1",
  MMA_MONTH: "MMAMO",
  MMA_FULL: "MMAFULL",

  TENNIS_ONE: "TENNIS1",
  TENNIS_MONTH: "TENNISMO",
  TENNIS_FULL: "TENNISFULL"
};

var MIN_PASSWORD_LENGTH = 8;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var AdminRepository = function () {
  function AdminRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AdminRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AdminRepository, [{
    key: "get",
    value: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/admin").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/admin/clearCache").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getGames",
    value: function getGames(sport) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/admin/odds/" + sport).then(function (response) {
        return response.data;
      });
    }
  }]);

  return AdminRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new AdminRepository();

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var PackageRepository = function () {
  function PackageRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PackageRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PackageRepository, [{
    key: "get",
    value: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/packages").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "create",
    value: function create(item) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/packages", item).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "update",
    value: function update(item) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put("/packages/" + item.id, item).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(item) {
      if (!item.id) return this.create(item);else return this.update(item);
    }
  }]);

  return PackageRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new PackageRepository();

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var RecordRepository = function () {
  function RecordRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RecordRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RecordRepository, [{
    key: "get",
    value: function get(page) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/records", {
        params: {
          page: page
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getForResultsPage",
    value: function getForResultsPage() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/records").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "one",
    value: function one(id) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/records/" + id).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(record) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put("/records/" + record.record_id, record).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "remove",
    value: function remove(record) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].delete("/records/" + record.record_id);
    }
  }]);

  return RecordRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new RecordRepository();

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var UserRepository = function () {
  function UserRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserRepository, [{
    key: "searchByEmail",
    value: function searchByEmail(email) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/admin/users?email=" + encodeURIComponent(email)).then(function (response) {
        return response.data.users.data;
      });
    }
  }, {
    key: "save",
    value: function save(user) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/admin/users", user).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new UserRepository();

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PICKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_EDIT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ODDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_SPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CURRENT_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_CART_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLEAR_CART; });
var SET_USER = "setUser";
var SET_SPORTS = "setSports";
var SET_PACKAGES = "setPackages";
var SET_CATS = "setCategories";
var SET_PICKS = "setPicks";
var SET_EDIT_USER = "setEditUser";
var SET_CURRENT_PACKAGE = "setCurrentPackage";

var SET_ODDS = "setOdds";
var SET_SPORT = "setSport";

var SET_PRODUCTS = "setProducts";
var SET_CURRENT_PRODUCT = "setCurrentProduct";
var ADD_TO_CART = "addToCart";
var UPDATE_CART_ITEM = "updateCartItem";
var REMOVE_FROM_CART = "removeFromCart";
var CLEAR_CART = "clearCart";

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-6d1f58ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  "data-v-1b7537d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */,
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Shell__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Shell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Shell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_FreePicks__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_FreePicks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_FreePicks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Package__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Faq__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Contact__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Register__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Testimonials__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Testimonials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Testimonials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PaymentSuccess__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_PaymentSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_PaymentSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Blog__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_ViewPicks__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_ViewPicks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_ViewPicks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_MyAccount__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_MyAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_MyAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_ChangePassword__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Disclaimer__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Disclaimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Disclaimer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Privacy__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Terms__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Odds__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Odds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Odds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Purchase__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Purchase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_tools_BetSizing__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_tools_BetSizing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_tools_BetSizing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Shop__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Shop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_ProductDetail__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_ProductDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_ProductDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Cart__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Checkout__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_OrderConfirmation__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_OrderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_OrderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_MyOrders__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_MyOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_MyOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Admin__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_admin_Pick__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_admin_Pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_admin_Pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_admin_Testimonial__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_admin_Testimonial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_admin_Testimonial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_admin_ManageTestimonial__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_admin_ManageTestimonial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_admin_ManageTestimonial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_admin_ManagePicks__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_admin_ManagePicks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_admin_ManagePicks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_admin_ManageRecord__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_admin_ManageRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_admin_ManageRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_admin_ManagePackages__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_admin_ManagePackages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_admin_ManagePackages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_admin_ManageCategories__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_admin_ManageCategories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_admin_ManageCategories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_admin_ManagePosts__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_admin_ManagePosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_admin_ManagePosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_admin_EditRecord__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_admin_EditRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_admin_EditRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_admin_EditPackage__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_admin_EditPackage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_admin_EditPackage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_admin_EditCategory__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_admin_EditCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_admin_EditCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_admin_EditPost__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_admin_EditPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_admin_EditPost__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_admin_Users__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_admin_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_admin_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_admin_EditUser__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_admin_EditUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_admin_EditUser__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });















































var routes = [{
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Shell___default.a,
  children: [{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a,
    name: "home"
  }, {
    path: "/freepicks",
    component: __WEBPACK_IMPORTED_MODULE_3__pages_FreePicks___default.a,
    name: "freepicks",
    meta: {
      breadcrumb: "Free Picks Blog",
      subtitle: "Free Picks Blog"
    }
  }, {
    path: "/packages/:sport",
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Package___default.a,
    name: "package",
    meta: {
      breadcrumb: "Packages",
      subtitle: "Packages"
    }
  }, {
    path: "/faq",
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Faq___default.a,
    name: "faq",
    meta: {
      breadcrumb: "FAQ",
      subtitle: "FAQ"
    }
  }, {
    path: "/contact",
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Contact___default.a,
    name: "contact",
    meta: {
      breadcrumb: "Contact",
      subtitle: "Contact"
    }
  }, {
    path: "/register",
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Register___default.a,
    name: "register",
    meta: {
      breadcrumb: "Register",
      subtitle: "Register"
    }
  }, {
    path: "/testimonials",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Testimonials___default.a,
    name: "testimonials",
    meta: {
      breadcrumb: "Testimonials",
      subtitle: "Testimonials"
    }
  }, {
    path: "/paymentsuccess",
    component: __WEBPACK_IMPORTED_MODULE_9__pages_PaymentSuccess___default.a,
    name: "payment_success"
  }, {
    path: "/odds",
    component: __WEBPACK_IMPORTED_MODULE_18__pages_Odds___default.a,
    name: "odds"
  }, {
    path: "/purchase",
    component: __WEBPACK_IMPORTED_MODULE_19__pages_Purchase___default.a,
    name: "purchase"
  }, {
    path: "/blog",
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Blog___default.a,
    name: "blog",
    meta: {
      breadcrumb: "Blog",
      subtitle: "Blog"
    }
  }, {
    path: "/viewpicks",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_ViewPicks___default.a,
    name: "picks",
    meta: {
      breadcrumb: "Premium Picks",
      subtitle: "View Premium Picks"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (!isPremium()) {
        return next("/packages/all");
      } else next();
    }
  }, {
    path: "/myaccount",
    component: __WEBPACK_IMPORTED_MODULE_12__pages_MyAccount___default.a,
    name: "myaccount",
    meta: {
      breadcrumb: "My Account",
      subtitle: "My Account"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return isLoggedIn(next);
    }
  }, {
    path: "/changepassword",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_ChangePassword___default.a,
    name: "changepassword",
    meta: {
      breadcrumb: "My Account",
      subtitle: "Change Password"
    }
  }, {
    path: "/disclaimer",
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Disclaimer___default.a,
    name: "disclaimer",
    meta: {
      breadcrumb: "Disclaimer",
      subtitle: "Disclaimer"
    }
  }, {
    path: "/privacy",
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Privacy___default.a,
    name: "privacy",
    meta: {
      breadcrumb: "Privacy",
      subtitle: "Privacy"
    }
  }, {
    path: "/terms",
    component: __WEBPACK_IMPORTED_MODULE_16__pages_Terms___default.a,
    name: "termsofuse",
    meta: {
      breadcrumb: "Terms of Use",
      subtitle: "Terms of Use"
    }
  }, {
    path: "/forgotpassword",
    component: __WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword___default.a,
    name: "forgotpassword",
    meta: {
      breadcrumb: "Home",
      subtitle: "Forgot Password"
    }
  }, {
    path: "/tools/size",
    component: __WEBPACK_IMPORTED_MODULE_20__pages_tools_BetSizing___default.a,
    name: "betsizing",
    meta: {
      breadcrumb: "Home",
      subtitle: "Bet Sizing Calculator"
    }
  }, {
    path: "/shop",
    component: __WEBPACK_IMPORTED_MODULE_21__pages_Shop___default.a,
    name: "shop",
    meta: {
      breadcrumb: "Shop",
      subtitle: "Shop"
    }
  }, {
    path: "/shop/:slug",
    component: __WEBPACK_IMPORTED_MODULE_22__pages_ProductDetail___default.a,
    name: "productdetail",
    meta: {
      breadcrumb: "Product Detail",
      subtitle: "Product Detail"
    }
  }, {
    path: "/cart",
    component: __WEBPACK_IMPORTED_MODULE_23__pages_Cart___default.a,
    name: "cart",
    meta: {
      breadcrumb: "Shopping Cart",
      subtitle: "Shopping Cart"
    }
  }, {
    path: "/checkout",
    component: __WEBPACK_IMPORTED_MODULE_24__pages_Checkout___default.a,
    name: "checkout",
    meta: {
      breadcrumb: "Checkout",
      subtitle: "Checkout"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return isLoggedIn(next);
    }
  }, {
    path: "/order-confirmation/:orderId",
    component: __WEBPACK_IMPORTED_MODULE_25__pages_OrderConfirmation___default.a,
    name: "orderconfirmation",
    meta: {
      breadcrumb: "Order Confirmation",
      subtitle: "Order Confirmation"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return isLoggedIn(next);
    }
  }, {
    path: "/my-orders",
    component: __WEBPACK_IMPORTED_MODULE_26__pages_MyOrders___default.a,
    name: "myorders",
    meta: {
      breadcrumb: "My Orders",
      subtitle: "My Orders"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return isLoggedIn(next);
    }
  }, {
    path: "/admin",
    component: __WEBPACK_IMPORTED_MODULE_27__pages_Admin___default.a,
    name: "admin",
    meta: {
      breadcrumb: "Admin",
      subtitle: "Admin"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/pick/:id?",
    component: __WEBPACK_IMPORTED_MODULE_28__pages_admin_Pick___default.a,
    name: "adminpick",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/picks",
    component: __WEBPACK_IMPORTED_MODULE_31__pages_admin_ManagePicks___default.a,
    name: "admin_manage_picks",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/testimonial/:id?",
    component: __WEBPACK_IMPORTED_MODULE_29__pages_admin_Testimonial___default.a,
    name: "admin_testimonial",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/testimonials",
    component: __WEBPACK_IMPORTED_MODULE_30__pages_admin_ManageTestimonial___default.a,
    name: "admin_manage_testimonials",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/record",
    component: __WEBPACK_IMPORTED_MODULE_32__pages_admin_ManageRecord___default.a,
    name: "admin_manage_record",
    meta: {
      breadcrumb: "Admin",
      subtitle: "Manage Record"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/categories",
    component: __WEBPACK_IMPORTED_MODULE_34__pages_admin_ManageCategories___default.a,
    name: "admin_manage_categories",
    meta: {
      breadcrumb: "Admin",
      subtitle: "Manage Categories"
    },
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/record/:id",
    component: __WEBPACK_IMPORTED_MODULE_36__pages_admin_EditRecord___default.a,
    name: "admin_edit_record",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/package",
    component: __WEBPACK_IMPORTED_MODULE_33__pages_admin_ManagePackages___default.a,
    name: "admin_manage_packages",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "admin/posts",
    component: __WEBPACK_IMPORTED_MODULE_35__pages_admin_ManagePosts___default.a,
    name: "admin_manage_posts",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/package/:id",
    component: __WEBPACK_IMPORTED_MODULE_37__pages_admin_EditPackage___default.a,
    name: "admin_edit_package",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/categories/:id",
    component: __WEBPACK_IMPORTED_MODULE_38__pages_admin_EditCategory___default.a,
    name: "admin_edit_category",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/posts/:id",
    component: __WEBPACK_IMPORTED_MODULE_39__pages_admin_EditPost___default.a,
    name: "admin_edit_post",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/users/",
    component: __WEBPACK_IMPORTED_MODULE_40__pages_admin_Users___default.a,
    name: "admin_users",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: "/admin/users/edit",
    component: __WEBPACK_IMPORTED_MODULE_41__pages_admin_EditUser___default.a,
    name: "admin_edit_user",
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }]
}];

function isAdmin() {
  return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser && __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser.admin;
}

function isPremium() {
  return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser && __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser.premium;
}

function isLoggedIn(next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser) next("/");else next();
}

function checkAdmin(next) {
  if (!isAdmin()) next("/");else next();
}

/***/ }),
/* 231 */,
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ContactRepository = function () {
  function ContactRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContactRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContactRepository, [{
    key: "send",
    value: function send(data) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://rocky-savannah-28401.herokuapp.com/api/v1' + "/contact", data).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ContactRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new ContactRepository();

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ContentRepository = function () {
  function ContentRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContentRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContentRepository, [{
    key: 'get',
    value: function get(data) {
      console.log(data);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/content/' + data).then(function (response) {
        console.log(response.data);
        return response.data;
      });
    }
  }]);

  return ContentRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new ContentRepository();

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var MemberRepository = function () {
  function MemberRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MemberRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MemberRepository, [{
    key: "get",
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/memberships?id=" + id, {}).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "save",
    value: function save(membership) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/memberships", membership).then(function (response) {
        return response.data;
      });
    }
  }]);

  return MemberRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new MemberRepository();

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var OddsRepository = function () {
  function OddsRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OddsRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OddsRepository, [{
    key: 'getLive',
    value: function getLive(sport) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/odds/live/' + (sport || ''), { params: { offset: new Date().getTimezoneOffset() / 60 } }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: 'getUpcoming',
    value: function getUpcoming(sport) {
      console.log(sport);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/odds/upcoming/' + (sport || ''), { params: { offset: new Date().getTimezoneOffset() / 60 } }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: 'getRecent',
    value: function getRecent(sport) {
      console.log(sport);
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/odds/upcoming/' + (sport || ''), { params: { offset: new Date().getTimezoneOffset() / 60 } }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: 'getForSport',
    value: function getForSport(sport) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(ODDS_URL + '/odds/' + sport).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }]);

  return OddsRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new OddsRepository();

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = buildCategories;
/* harmony export (immutable) */ __webpack_exports__["f"] = filterRows;
/* harmony export (immutable) */ __webpack_exports__["d"] = rowLabel;
/* harmony export (immutable) */ __webpack_exports__["c"] = propGames;
/* harmony export (immutable) */ __webpack_exports__["g"] = propsForGame;
/* harmony export (immutable) */ __webpack_exports__["e"] = propRowLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = filterPropsInGame;
/* harmony export (immutable) */ __webpack_exports__["a"] = isYesNoProp;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildPickString;


function label(row) {
  return row.AwayTeam + ' vs. ' + row.HomeTeam + ' \u2014 ' + row.MatchTime;
}

function propLabel(row) {
  var name = row.Participant && row.Participant.Name ? row.Participant.Name : 'Player';
  return name + ' (' + row.AwayTeam + ' vs. ' + row.HomeTeam + ') \u2014 ' + row.PropType;
}

function buildCategories(payload) {
  var cats = [];
  cats.push({ key: 'Game', label: 'Game', mode: 'game', rows: payload.games || [] });(payload.oddsTypes || []).forEach(function (ot) {
    cats.push({ key: ot.oddsType, label: ot.oddsType, mode: 'game', rows: ot.games || [] });
  });

  if (payload.props && payload.props.length) {
    cats.push({ key: 'Props', label: 'Props', mode: 'prop', rows: payload.props });
  }
  return cats;
}

function filterRows(category, query) {
  if (!category) return [];
  var q = (query || '').trim().toLowerCase();
  if (!q) return category.rows;
  if (category.mode === 'prop') {
    return category.rows.filter(function (r) {
      var name = (r.Participant && r.Participant.Name ? r.Participant.Name : '').toLowerCase();
      var prop = (r.PropType || '').toLowerCase();
      var teams = ((r.AwayTeam || '') + ' ' + (r.HomeTeam || '')).toLowerCase();
      return name.indexOf(q) !== -1 || prop.indexOf(q) !== -1 || teams.indexOf(q) !== -1;
    });
  }
  return category.rows.filter(function (r) {
    var teams = ((r.AwayTeam || '') + ' ' + (r.HomeTeam || '')).toLowerCase();
    return teams.indexOf(q) !== -1;
  });
}

function rowLabel(category, row) {
  if (!row) return '';
  return category && category.mode === 'prop' ? propLabel(row) : label(row);
}

function humanizePropType(propType) {
  if (!propType) return '';
  return String(propType).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

function propGames(payload) {
  var seen = {};
  var games = [];(payload.props || []).forEach(function (p) {
    var id = p.EventID;
    if (id == null || seen[id]) return;
    seen[id] = true;
    games.push({
      ID: id,
      EventID: id,
      HomeTeam: p.HomeTeam,
      AwayTeam: p.AwayTeam,
      MatchTime: p.MatchTime
    });
  });
  return games;
}

function propsForGame(payload, eventId) {
  if (eventId == null) return [];
  return (payload.props || []).filter(function (p) {
    return p.EventID === eventId;
  });
}

function propRowLabel(row) {
  if (!row) return '';
  var name = row.Participant && row.Participant.Name ? row.Participant.Name : 'Player';
  return name + ' \u2014 ' + humanizePropType(row.PropType);
}

function filterPropsInGame(rows, query) {
  var q = (query || '').trim().toLowerCase();
  if (!q) return rows || [];
  return (rows || []).filter(function (r) {
    var name = (r.Participant && r.Participant.Name ? r.Participant.Name : '').toLowerCase();
    var prop = humanizePropType(r.PropType).toLowerCase();
    return name.indexOf(q) !== -1 || prop.indexOf(q) !== -1;
  });
}

function isYesNoProp(row) {
  if (!row) return false;
  var o = row.Odds && row.Odds[0] || {};
  var total = parseFloat(o.TotalNumber);
  return !(total > 0);
}

function buildPickString(categoryKey, row, sideValue) {
  if (!row) return '';
  if (categoryKey === 'Props') {
    var name = row.Participant && row.Participant.Name ? row.Participant.Name : 'Player';
    var propText = humanizePropType(row.PropType);
    if (isYesNoProp(row)) {
      var yn = sideValue === 'no' ? 'NO' : 'YES';
      return (name + ' ' + yn + ' ' + propText).replace(/\s+/g, ' ').trim();
    }
    var num = row.Odds && row.Odds[0] ? row.Odds[0].TotalNumber : '';
    var dir = sideValue === 'under' ? 'UNDER' : 'OVER';
    return (name + ' ' + dir + ' ' + num + ' ' + propText).replace(/\s+/g, ' ').trim();
  }

  switch (sideValue) {
    case 'home':
      return row.HomeTeam;
    case 'away':
      return row.AwayTeam;
    case 'over':
      return row.AwayTeam + ' vs. ' + row.HomeTeam + ' OVER';
    case 'under':
      return row.AwayTeam + ' vs. ' + row.HomeTeam + ' UNDER';
    default:
      return '';
  }
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var PrerenderRepository = function () {
  function PrerenderRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PrerenderRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PrerenderRepository, [{
    key: 'update',
    value: function update() {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://api.prerender.io/recache', {
        prerenderToken: '' + 'Wqg3BRBjCD5QuIvMJgzK',
        url: 'https://www.stumpthespread.com/'
      });
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://api.prerender.io/recache', {
        prerenderToken: '' + 'Wqg3BRBjCD5QuIvMJgzK',
        url: 'https://www.stumpthespread.com/freepicks'
      });
    }
  }]);

  return PrerenderRepository;
}();

/* unused harmony default export */ var _unused_webpack_default_export = new PrerenderRepository();

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var PurchaseRepository = function () {
  function PurchaseRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PurchaseRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PurchaseRepository, [{
    key: "create",
    value: function create(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/orders", data);
    }
  }, {
    key: "capture",
    value: function capture(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/orders/" + data.orderID + "/capture");
    }
  }]);

  return PurchaseRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new PurchaseRepository();

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var ResultRepository = function () {
  function ResultRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ResultRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ResultRepository, [{
    key: "get",
    value: function get(name, sportsId) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get("/results", {
        params: {
          name: name,
          sports_id: sportsId
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ResultRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new ResultRepository();

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var SportRepository = function () {
  function SportRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SportRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SportRepository, [{
    key: "get",
    value: function get() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + "/sports").then(function (response) {
        return response.data;
      });
    }
  }]);

  return SportRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new SportRepository();

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(6);




var ToolRepository = function () {
  function ToolRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ToolRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ToolRepository, [{
    key: "size",
    value: function size(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post("/tools/size", data).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ToolRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = new ToolRepository();

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_sport_repository__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_package_repository__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_category_repository__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_pick_repository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_odds_repository__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_product_repository__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutation_types__ = __webpack_require__(74);










/* harmony default export */ __webpack_exports__["a"] = {
  login: function login(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__["a" /* default */].login(data.email, data.password).then(function (response) {
        localStorage.setItem("sts_token", response.token);
        context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* SET_USER */], response.user);
        resolve(response.user);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  logout: function logout(context, data) {
    localStorage.removeItem("sts_token");
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* SET_USER */]);
  },
  getStoredUser: function getStoredUser(context, data) {
    var token = void 0;
    try {
      token = localStorage.getItem("sts_token");
    } catch (err) {}
    if (!token) {
      return context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* SET_USER */], null);
    } else {
      return __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__["a" /* default */].get(token).then(function (user) {
        return context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* SET_USER */], user);
      }).catch(function () {
        localStorage.removeItem("sts_token");
        return context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["a" /* SET_USER */], null);
      });
    }
  },
  getSports: function getSports(context, data) {
    __WEBPACK_IMPORTED_MODULE_2__data_sport_repository__["a" /* default */].get().then(function (sports) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["b" /* SET_SPORTS */], sports);
    });
  },
  getPackages: function getPackages(context, data) {
    __WEBPACK_IMPORTED_MODULE_3__data_package_repository__["a" /* default */].get().then(function (ps) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["c" /* SET_PACKAGES */], ps);
    });
  },
  getCategories: function getCategories(context, data) {
    __WEBPACK_IMPORTED_MODULE_4__data_category_repository__["a" /* default */].get().then(function (cats) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["d" /* SET_CATS */], cats);
    });
  },
  getFreePicks: function getFreePicks(context, data) {
    __WEBPACK_IMPORTED_MODULE_5__data_pick_repository__["a" /* default */].getFreePicks().then(function (picks) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["e" /* SET_PICKS */], picks);
    });
  },
  getUpcoming: function getUpcoming(context, sport) {
    return __WEBPACK_IMPORTED_MODULE_6__data_odds_repository__["a" /* default */].getUpcoming(sport).then(function (odds) {
      if (!odds) return;
      return context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["f" /* SET_ODDS */], {
        sport: sport,
        data: {
          upcoming: {
            data: odds
          }
        }
      });
    });
  },
  getLive: function getLive(context, sport) {
    return __WEBPACK_IMPORTED_MODULE_6__data_odds_repository__["a" /* default */].getLive(sport).then(function (odds) {
      if (!odds) return;
      return context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["f" /* SET_ODDS */], {
        sport: sport,
        data: {
          live: {
            data: odds
          }
        }
      });
    });
  },
  setCurrentPackage: function setCurrentPackage(context, p) {
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["g" /* SET_CURRENT_PACKAGE */], p);
  },
  getProducts: function getProducts(context) {
    return __WEBPACK_IMPORTED_MODULE_7__data_product_repository__["a" /* default */].getAll().then(function (products) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["h" /* SET_PRODUCTS */], products);
      return products;
    });
  },
  getProductBySlug: function getProductBySlug(context, slug) {
    return __WEBPACK_IMPORTED_MODULE_7__data_product_repository__["a" /* default */].getBySlug(slug).then(function (product) {
      context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["i" /* SET_CURRENT_PRODUCT */], product);
      return product;
    });
  },
  addToCart: function addToCart(context, item) {
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* ADD_TO_CART */], item);
  },
  updateCartItem: function updateCartItem(context, payload) {
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* UPDATE_CART_ITEM */], payload);
  },
  removeFromCart: function removeFromCart(context, variantId) {
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["l" /* REMOVE_FROM_CART */], variantId);
  },
  clearCart: function clearCart(context) {
    context.commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["m" /* CLEAR_CART */]);
  }
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = {
  package: function _package(state, getters) {
    return function (id) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.packages, ["id", id]);
    };
  },
  packagesBySport: function packagesBySport(state, getters) {
    return function (sport) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.packages, ["sports_id", sport]), "id").reverse();
    };
  },
  sports: function sports(state, getters) {
    return function () {
      return state.sports;
    };
  },
  picks: function picks(state, getters) {
    return function () {
      return state.picks;
    };
  },
  editUser: function editUser(state, getters) {
    return function () {
      return state.editUser;
    };
  },
  upcoming: function upcoming(state) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(state.odds[state.selectedSport], "upcoming.data") || [];
    };
  },
  live: function live(state) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(state.odds[state.selectedSport], "live.data") || [];
    };
  },
  recent: function recent(state) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(state.odds[state.selectedSport], "recent.data") || [];
    };
  },
  oddsForSport: function oddsForSport(state) {
    return function () {
      return state.odds[state.sport] || { upcoming: {}, live: {} };
    };
  },

  cartItemCount: function cartItemCount(state) {
    return state.cart.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
  },
  cartTotal: function cartTotal(state) {
    return state.cart.reduce(function (total, item) {
      return total + item.price * item.quantity;
    }, 0);
  }
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);



var _SET_USER$SET_SPORTS$;




/* harmony default export */ __webpack_exports__["a"] = _SET_USER$SET_SPORTS$ = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */], function (state, user) {
  state.currentUser = user;
  state.isAuthenticated = !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(state.currentUser);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_SPORTS */], function (state, sports) {
  state.sports = sports;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_PACKAGES */], function (state, packages) {
  state.packages = packages;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_CATS */], function (state, cats) {
  state.categories = cats;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_PICKS */], function (state, picks) {
  state.picks = picks;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* SET_EDIT_USER */], function (state, user) {
  state.editUser = user;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_ODDS */], function (state, data) {
  var sport = state.selectedSport;
  console.log(data.data);
  var sp = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.assignIn({}, state.odds[sport], state.odds[sport], data.data);
  state.odds = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.assignIn({}, state.odds, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, sport, sp));
  console.log(state.odds["mlb"]);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* SET_SPORT */], function (state, data) {
  state.sport = data;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* SET_CURRENT_PACKAGE */], function (state, p) {
  state.currentPackage = p;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SET_PRODUCTS */], function (state, products) {
  state.products = products;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_CURRENT_PRODUCT */], function (state, product) {
  state.currentProduct = product;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* ADD_TO_CART */], function (state, item) {
  var existingItem = state.cart.find(function (i) {
    return i.variantId === item.variantId;
  });
  if (existingItem) {
    existingItem.quantity += item.quantity;
  } else {
    state.cart.push(item);
  }
  localStorage.setItem("sts_cart", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.cart));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* UPDATE_CART_ITEM */], function (state, _ref) {
  var variantId = _ref.variantId,
      quantity = _ref.quantity;

  var item = state.cart.find(function (i) {
    return i.variantId === variantId;
  });
  if (item) {
    item.quantity = quantity;
  }
  localStorage.setItem("sts_cart", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.cart));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* REMOVE_FROM_CART */], function (state, variantId) {
  state.cart = state.cart.filter(function (i) {
    return i.variantId !== variantId;
  });
  localStorage.setItem("sts_cart", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.cart));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_SPORTS$, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* CLEAR_CART */], function (state) {
  state.cart = [];
  localStorage.removeItem("sts_cart");
}), _SET_USER$SET_SPORTS$;

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: "app", mounted: function mounted() {
    this.$refs.toastr.defaultPosition = "toast-bottom-right";
  }
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'SearchableSelect',
  props: {
    items: { type: Array, default: function _default() {
        return [];
      } },

    rowLabelFn: { type: Function, required: true },

    rowKey: { type: Function, required: true },

    filterFn: { type: Function, required: true },
    placeholder: { type: String, default: 'Type to search…' },

    initialLabel: { type: String, default: '' }
  },
  data: function data() {
    return { query: this.initialLabel, open: false, highlight: 0 };
  },

  computed: {
    rows: function rows() {
      return this.filterFn(this.query);
    },
    highlighted: function highlighted() {
      return this.rows[this.highlight];
    }
  },
  watch: {
    initialLabel: function initialLabel(val) {
      this.query = val;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.onDocClick = function (e) {
      if (_this.$el && !_this.$el.contains(e.target)) _this.close();
    };
    document.addEventListener('click', this.onDocClick);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
  },

  methods: {
    move: function move(delta) {
      if (!this.rows.length) return;
      this.open = true;
      this.highlight = (this.highlight + delta + this.rows.length) % this.rows.length;
    },
    choose: function choose(row) {
      if (!row) return;
      this.query = this.rowLabelFn(row);
      this.open = false;
      this.$emit('select', row);
    },
    close: function close() {
      this.open = false;
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    },
    adLayoutKey: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted: function mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      username: "",
      password: "",
      error: ""
    };
  },
  mounted: function mounted() {
    var savedUsername = localStorage.getItem('sts_username');
    if (savedUsername) {
      this.username = savedUsername;
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      if (!this.username || !this.password) return;
      this.$store.dispatch("login", { email: this.username, password: this.password }).then(function (user) {
        localStorage.setItem('sts_username', _this.username);
        _this.username = "";
        _this.password = "";
        document.querySelector("#fancybox-close").click();
        _this.error = "";
        _this.$root.$refs.toastr.s("Login Successful");
      }).catch(function () {
        _this.error = "Login Failed";
      });
    },
    reset: function reset() {
      document.querySelector("#fancybox-close").click();
      this.$router.push("/forgotpassword");
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: ['package', 'size', 'color'],
  data: function data() {
    return {
      id: -1,
      mutableSize: this.size || 'small',
      mutableColor: this.color || 'silver'
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    packageId: function packageId() {
      return this.package.id;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.id = 'p' + this._uid;
    var that = this;
    this.$nextTick(function () {
      paypal.Button.render({
        env: '' + 'production',
        style: {
          size: _this.mutableSize,
          shape: 'rect',
          color: _this.mutableColor
        },
        commit: true,
        payment: function payment(resolve, reject) {
          if (!that.currentUser || !that.currentUser.id) {
            return reject(new Error('User is not logged in'));
          }
          var CREATE_PAYMENT_URL = 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/payment';
          paypal.request.post(CREATE_PAYMENT_URL, { id: that.packageId, userID: that.currentUser.id }).then(function (data) {
            resolve(data.paymentID);
          }).catch(function (err) {
            reject(err);
          });
        },
        onAuthorize: function onAuthorize(data, actions) {
          var EXECUTE_PAYMENT_URL = 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/payment/execute';
          paypal.request.post(EXECUTE_PAYMENT_URL, { paymentID: data.paymentID, payerID: data.payerID, userID: that.currentUser.id, packageID: that.packageId }).then(function (data) {
            that.$router.push('/paymentsuccess');
          }).catch(function (err) {
            console.log(err);
          });
        },
        onClick: function onClick() {
          if (!that.currentUser || !that.currentUser.id) {
            that.$root.$refs.toastr.w('Please log in or register to become a Premium Member');
            return that.$router.push('/register');
          }
        },
        onCancel: function onCancel(data, actions) {},
        onError: function onError(err) {
          if (err && err.message && err.message.indexOf('User is not logged in') < 0) {
            console.log(err);
            that.$root.$refs.toastr.e('An error occurred processing the payment, please contact support@stumpthespread.com');
          }
        }
      }, '#' + _this.id);
    });
  }
};

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: ['pick'],
  data: function data() {
    return {};
  }
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  components: {},
  props: ['package', 'color', 'fullWidth'],
  data: function data() {
    return {
      mutableColor: this.color || 'grey',
      mutableFullWidth: this.fullWidth || false
    };
  },

  computed: {
    computedStyle: function computedStyle() {
      return {
        margin: this.mutableFullWidth ? 'none' : '8px auto'
      };
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.currentUser || !this.currentUser.id) {
        this.$root.$refs.toastr.w('Please log in or register to become a Premium Member');
        return this.$router.push('/register');
      }
      this.$store.dispatch("setCurrentPackage", this.package);
      this.$router.push('/purchase');
    }
  }
};

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__testimonial_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__testimonial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__testimonial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paypalButton_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paypalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paypalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_adsense_vue__);








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    testimonial: __WEBPACK_IMPORTED_MODULE_1__testimonial_vue___default.a,

    purchaseButton: __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue___default.a,
    adsense: __WEBPACK_IMPORTED_MODULE_4__components_adsense_vue___default.a
  },
  props: ["testimonial", "packages"],
  data: function data() {
    return {};
  },

  computed: {
    ps: function ps() {
      if (!this.packages) return this.$store.getters.packagesBySport("2343a835-82ae-4b4b-bb50-689912b97571").filter(function (p) {
        return !p.special;
      });else return this.packages;
    }
  }
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: ["test"],
  data: function data() {
    return {};
  }
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_admin_repository_js__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      admin: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__data_admin_repository_js__["a" /* default */].get().then(function (data) {
      _this.admin = data;
    });
  },

  methods: {
    clearCache: function clearCache() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__data_admin_repository_js__["a" /* default */].clearCache().then(function (result) {
        _this2.$root.$refs.toastr.s("Cache emptied");
      });
    }
  }
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    adsense: __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      posts: [],
      archives: [],
      category: "",
      month: "",
      year: "",
      page: 0,
      total: 0,
      current: 0
    };
  },

  computed: {
    categories: function categories() {
      return this.$store.state.categories;
    },
    hideMore: function hideMore() {
      return this.current >= this.total;
    }
  },
  created: function created() {
    var _this = this;

    this.next();
    __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].archives().then(function (data) {
      _this.archives = data;
      _this.current = data.to;
      _this.page = data.current_page;
      _this.records = data.data;
    });
  },

  methods: {
    next: function next() {
      var _this2 = this;

      if (this.current >= this.total && this.page !== 0) return;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].get(this.page + 1, this.category, this.month, this.year).then(function (data) {
        _this2.total = data.total;
        _this2.current = data.to;
        _this2.page = data.current_page;
        _this2.posts = _this2.posts.concat(data.data);
      });
    },
    catClick: function catClick(cat) {
      var _this3 = this;

      this.category = cat.id;
      this.month = "";
      this.year = "";
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].get(1, cat.id).then(function (data) {
        _this3.posts = data.data;
        _this3.current = data.to;
        _this3.page = data.current_page;
        _this3.total = data.total;
      });
    },
    archiveClick: function archiveClick(archive) {
      var _this4 = this;

      this.category = "";
      this.month = archive.month;
      this.year = archive.year;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].get(1, null, archive.month, archive.year).then(function (data) {
        _this4.posts = data.data;
        _this4.current = data.to;
        _this4.page = data.current_page;
        _this4.total = data.total;
      });
    }
  },
  metaInfo: {
    title: "Blog"
  }
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Cart',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['cart', 'isAuthenticated']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['cartItemCount', 'cartTotal'])),
  methods: {
    incrementQuantity: function incrementQuantity(item) {
      this.$store.dispatch('updateCartItem', {
        variantId: item.variantId,
        quantity: item.quantity + 1
      });
    },
    decrementQuantity: function decrementQuantity(item) {
      if (item.quantity > 1) {
        this.$store.dispatch('updateCartItem', {
          variantId: item.variantId,
          quantity: item.quantity - 1
        });
      }
    },
    updateQuantity: function updateQuantity(item) {
      if (item.quantity < 1) {
        item.quantity = 1;
      }
      this.$store.dispatch('updateCartItem', {
        variantId: item.variantId,
        quantity: item.quantity
      });
    },
    removeItem: function removeItem(item) {
      if (confirm('Remove ' + item.name + ' from cart?')) {
        this.$store.dispatch('removeFromCart', item.variantId);
      }
    },
    formatPrice: function formatPrice(price) {
      return price.toFixed(2);
    }
  }
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_auth_repository__ = __webpack_require__(23);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: ''
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        var obj = { oldPassword: _this.oldPassword, newPassword: _this.newPassword, confirmPassword: _this.confirmPassword, id: _this.user.id };
        __WEBPACK_IMPORTED_MODULE_0__data_auth_repository__["a" /* default */].changePassword(obj).then(function (result) {
          _this.$root.$refs.toastr.s('Password updated');
          _this.$router.push('/myaccount');
        }).catch(function (e) {
          if (e.response && e.response.data && e.response.data.error) {
            _this.error = e.response.data.error;
          }
        });
      });
    }
  },
  metaInfo: {
    title: 'Change Password'
  }
};

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_product_repository__ = __webpack_require__(27);









/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Checkout',
  data: function data() {
    return {
      shipping: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        postal_code: '',
        country: 'US'
      },
      processing: false,
      processingMessage: '',
      error: null,
      orderCreated: false,
      currentOrderId: null,
      cardField: null,
      cardSubmitDisabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['cart', 'isAuthenticated', 'currentUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['cartTotal', 'cartItemCount'])),
  mounted: function mounted() {
    var _createOrder = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cartData, shippingData, response, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (that.validateForm()) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Please fill in all required fields');

              case 2:
                _context.prev = 2;
                cartData = that.cart.map(function (item) {
                  return {
                    variant_id: item.variantId,
                    quantity: item.quantity,
                    price: item.price
                  };
                });
                shippingData = {
                  name: (that.shipping.first_name + ' ' + that.shipping.last_name).trim(),
                  email: that.shipping.email,
                  phone: that.shipping.phone,
                  address1: that.shipping.address_line1,
                  address2: that.shipping.address_line2,
                  city: that.shipping.city,
                  state: that.shipping.state,
                  postal_code: that.shipping.postal_code,
                  country: that.shipping.country
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__data_product_repository__["a" /* default */].createOrder({
                  cart: cartData,
                  shipping: shippingData
                });

              case 7:
                response = _context.sent;


                console.log('Create order response:', response);

                if (!response.paypal_order_id) {
                  _context.next = 14;
                  break;
                }

                that.currentOrderId = response.order_id;
                return _context.abrupt('return', response.paypal_order_id);

              case 14:
                errorMessage = 'Failed to create PayPal order';

                console.error(errorMessage, response);
                throw new Error(errorMessage);

              case 17:
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](2);

                console.error('Create order error:', _context.t0);
                that.error = 'There was an issue processing your payment';
                throw _context.t0;

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 19]]);
      }));

      return function _createOrder() {
        return _ref.apply(this, arguments);
      };
    }();

    var _onApprove = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('_onApprove called with data:', data);
                that.processingMessage = 'Processing payment...';

                _context2.prev = 2;

                console.log('Capturing payment for order ID:', that.currentOrderId);
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__data_product_repository__["a" /* default */].captureOrder(that.currentOrderId);

              case 6:

                console.log('Payment captured successfully');
                that.processingMessage = 'Payment successful! Redirecting...';

                that.$store.dispatch('clearCart');

                that.$router.push('/order-confirmation/' + that.currentOrderId);
                _context2.next = 18;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

                that.processing = false;
                that.error = _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message || 'Payment capture failed. Please contact support.';
                console.error('Capture payment error:', _context2.t0);
                throw _context2.t0;

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 12]]);
      }));

      return function _onApprove(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    if (!this.isAuthenticated) {
      this.$router.push('/register');
      return;
    }

    if (this.currentUser && this.currentUser.email) {
      this.shipping.email = this.currentUser.email;
    }

    var that = this;

    this.$nextTick(function () {
      paypal.Buttons({
        createOrder: _createOrder,
        onApprove: _onApprove,
        onError: function onError(err) {
          that.processing = false;
          that.error = 'Payment failed. Please try again.';
          console.error('PayPal error:', err);
        },
        style: {
          shape: 'rect',
          layout: 'vertical',
          color: 'gold',
          label: 'paypal'
        }
      }).render('#paypal-button-container');

      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            'font-size': '16px',
            'font-family': 'helvetica, tahoma, calibri, sans-serif',
            color: '#333333'
          },
          '.invalid': { color: 'red' }
        }
      });

      if (that.cardField.isEligible()) {
        var nameField = that.cardField.NameField();
        nameField.render('#card-name-field-container');

        var numberField = that.cardField.NumberField();
        numberField.render('#card-number-field-container');

        var cvvField = that.cardField.CVVField();
        cvvField.render('#card-cvv-field-container');

        var expiryField = that.cardField.ExpiryField();
        expiryField.render('#card-expiry-field-container');
      } else {
        that.error = 'Card fields are not available at this time. Please reach out to support@stumpthespread.com';
      }
    });
  },

  methods: {
    submitCardPayment: function submitCardPayment() {
      var _this = this;

      if (this.cardSubmitDisabled) return;

      if (!this.validateForm()) {
        return;
      }

      this.cardSubmitDisabled = true;
      this.error = null;

      this.cardField.submit({}).then(function (data) {
        console.log(data);
      }).catch(function (err) {
        console.error('Card payment error:', err);

        if (err.message && err.message.indexOf('DECLINED') > -1) {
          _this.error = 'Payment declined. Please check your card details and try again.';
        } else if (err.message === 'INVALID_NUMBER') {
          _this.error = 'Invalid card number. Please check and try again.';
        } else if (err.message === 'INVALID_EXPIRY') {
          _this.error = 'Invalid expiration date. Please check and try again.';
        } else if (err.message === 'INVALID_CVV') {
          _this.error = 'Invalid CVV. Please check and try again.';
        } else {
          _this.error = err.message || 'Payment failed. Please check your card details and try again.';
        }
      }).finally(function () {
        _this.cardSubmitDisabled = false;
      });
    },
    validateForm: function validateForm() {
      var required = ['first_name', 'last_name', 'email', 'address_line1', 'city', 'state', 'postal_code', 'country'];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(required), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (!this.shipping[field] || this.shipping[field].trim() === '') {
            this.error = 'Please fill in all required fields';
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.shipping.email)) {
        this.error = 'Please enter a valid email address';
        return false;
      }

      return true;
    },
    formatPrice: function formatPrice(price) {
      return price.toFixed(2);
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_testimonial_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_testimonial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_testimonial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_contact_repository__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__);







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'testimonial': __WEBPACK_IMPORTED_MODULE_1__components_testimonial_vue___default.a,
    'adsense': __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default.a,
    'vueRecaptcha': __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha___default.a
  },
  data: function data() {
    return {
      testimonial: {},
      captcha: false,
      success: false,
      contact: {
        from: '',
        name: '',
        message: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  methods: {
    send: function send() {
      var _this2 = this;

      if (!this.captcha) return this.$root.$refs.toastr.e('Enter Captcha');
      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_3__data_contact_repository__["a" /* default */].send(_this2.contact).then(function (result) {
          _this2.success = true;
        }).catch(function () {
          return _this2.$root.$refs.toastr.e('An Error has Occurred');
        });
      });
    },
    onVerify: function onVerify() {
      this.captcha = true;
    }
  },
  metaInfo: {
    title: 'Contact'
  }
};

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar__);



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'sidebar': __WEBPACK_IMPORTED_MODULE_0__components_sidebar___default.a
  },
  data: function data() {
    return {};
  },

  metaInfo: {
    title: 'Disclaimer'
  }
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository_js__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'sidebar': __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default.a,
    'adsense': __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      testimonial: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  metaInfo: {
    title: 'FAQ'
  }
};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_auth_repository_js__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'sidebar': __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default.a
  },
  data: function data() {
    return {
      email: '',
      success: false,
      testimonial: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  methods: {
    reset: function reset() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_2__data_auth_repository_js__["a" /* default */].resetPassword(_this2.email).then(function (result) {
          _this2.success = true;
          _this2.$root.$refs.toastr.s('Password Request has been Sent');
        }).catch(function () {
          return _this2.$root.$refs.toastr.e('An error occurred');
        });
      });
    }
  },
  metaInfo: {
    title: 'Forgot Password'
  }
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pick_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pick_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pick_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_adsense_vue__);






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default.a,
    pick: __WEBPACK_IMPORTED_MODULE_1__components_pick_vue___default.a,
    adsense: __WEBPACK_IMPORTED_MODULE_3__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      testimonial: {}
    };
  },

  computed: {
    picks: function picks() {
      return this.$store.getters.picks();
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  metaInfo: {
    title: "Free Picks"
  }
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_paypalButton_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_paypalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_paypalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_purchaseButton_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_purchaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_purchaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_testimonial_repository_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_auth_repository_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_adsense_vue__);








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    purchaseButton: __WEBPACK_IMPORTED_MODULE_1__components_purchaseButton_vue___default.a,

    adsense: __WEBPACK_IMPORTED_MODULE_5__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      testimonial: "",
      count: 0,
      posts: ""
    };
  },

  computed: {
    allWeek: function allWeek() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* PACKAGES */].ALL_ONE);
    },
    allWeekPrice: function allWeekPrice() {
      return this.allWeek ? this.allWeek.current_price : "";
    },
    allTwo: function allTwo() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* PACKAGES */].ALL_TWO);
    },
    allTwoPrice: function allTwoPrice() {
      return this.allTwo ? this.allTwo.current_price : "";
    },
    allMonth: function allMonth() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* PACKAGES */].ALL_MONTH);
    },
    allMonthPrice: function allMonthPrice() {
      return this.allMonth ? this.allMonth.current_price : "";
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
    __WEBPACK_IMPORTED_MODULE_4__data_auth_repository_js__["a" /* default */].count().then(function (res) {
      _this.count = res;
    });
  }
};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_auth_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(32);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      notifyEmail: false,
      notifyPush: false,
      notifySms: false,
      contactEmail: "",
      contactPhone: "",
      phone: {},
      phoneOpts: [{ key: "Select Carrier", value: 0 }, { key: "Verizon", value: 2 }, { key: "T-Mobile", value: 3 }, { key: "Sprint", value: 4 }, { key: "U.S. Cellular", value: 5 }, { key: "Virgin Mobile", value: 6 }, { key: "Tracfone", value: 7 }, { key: "Metro PCS", value: 8 }, { key: "Boost Mobile", value: 9 }, { key: "Cricket", value: 10 }, { key: "Nextel", value: 11 }, { key: "Alltel", value: 12 }, { key: "Ptel", value: 13 }, { key: "Suncom", value: 14 }, { key: "Qwest", value: 15 }]
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.currentUser;
    }
  },
  mounted: function mounted() {
    var u = this.$store.state.currentUser;

    if (u.notify_email !== undefined) {
      this.notifyEmail = !!u.notify_email;
    } else {
      this.notifyEmail = u.contact_method === 1;
    }
    if (u.notify_push !== undefined) {
      this.notifyPush = !!u.notify_push;
    }
    if (u.notify_sms !== undefined) {
      this.notifySms = !!u.notify_sms;
    } else {
      this.notifySms = u.contact_method === 2;
    }

    if (u.contact_method === 1 && u.contact_email) {
      this.contactEmail = u.contact_email;
    } else if (u.email) {
      this.contactEmail = u.email;
    }
    if (u.contact_method === 2 && u.contact_email) {
      this.contactPhone = u.contact_email;
    }

    if (!u.contact_phone || u.contact_phone === 0) {
      this.phone = this.phoneOpts[0];
    } else if (u.contact_phone) {
      this.phone = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.phoneOpts, ["value", u.contact_phone]) || this.phoneOpts[0];
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_email: this.notifyEmail ? 1 : 0,
        notify_push: this.notifyPush ? 1 : 0,
        notify_sms: this.notifySms ? 1 : 0,
        contact_method: this.notifySms ? 2 : this.notifyEmail ? 1 : 0,
        contact_email: this.notifyEmail ? this.contactEmail : this.notifySms ? this.contactPhone : "",
        contact_phone: this.notifySms ? this.phone.value || 0 : 0
      };
      __WEBPACK_IMPORTED_MODULE_0__data_auth_repository__["a" /* default */].save(payload).then(function (result) {
        _this.$store.dispatch("getStoredUser");
        _this.$root.$refs.toastr.s("User saved");
      }).catch(function () {
        return _this.$root.$refs.toastr.e("An error occurred");
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].dispatch("getStoredUser").then(function () {
      var u = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */].state.currentUser;
      if (!u || !u.id) return next("/");
      next();
    });
  },

  metaInfo: {
    title: "My Account"
  }
};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_product_repository__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'MyOrders',
  data: function data() {
    return {
      orders: [],
      loading: false,
      error: null
    };
  },
  mounted: function mounted() {
    this.loadOrders();
  },

  methods: {
    loadOrders: function loadOrders() {
      var _this = this;

      this.loading = true;
      this.error = null;

      __WEBPACK_IMPORTED_MODULE_0__data_product_repository__["a" /* default */].getUserOrders().then(function (orders) {
        _this.orders = orders;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Failed to load orders. Please try again later.';
        console.error('Error loading orders:', err);
      });
    },
    viewOrder: function viewOrder(orderId) {
      this.$router.push('/order-confirmation/' + orderId);
    },
    getPrimaryImage: function getPrimaryImage(product) {
      if (!product || !product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    formatStatus: function formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
    }
  }
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {},
  data: function data() {
    return {
      oddTypes: [{ label: "Moneyline", value: "moneyline" }, { label: "Spread", value: "spread" }, { label: "Total", value: "total" }],
      odds: this.$store.state.odds
    };
  },

  computed: {
    upcomingHeaders: function upcomingHeaders() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.odds, "mlb.upcoming.data.headers", []);
    },
    upcomingGames: function upcomingGames() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.odds, "mlb.upcoming.data.games", []);
    }
  },
  created: function created() {
    var _this = this;

    this.oddType = this.oddTypes[0];
    return this.loadData().then(function () {
      _this.odds = _this.$store.state.odds;
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.odds));
    });
  },

  methods: {
    loadData: function loadData() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch("getUpcoming", "mlb"), this.$store.dispatch("getLive", "mlb")]);
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_product_repository__ = __webpack_require__(27);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'OrderConfirmation',
  data: function data() {
    return {
      order: null,
      loading: false,
      error: null
    };
  },
  mounted: function mounted() {
    this.loadOrder();
  },

  methods: {
    loadOrder: function loadOrder() {
      var _this = this;

      this.loading = true;
      this.error = null;

      var orderId = this.$route.params.orderId;

      __WEBPACK_IMPORTED_MODULE_0__data_product_repository__["a" /* default */].getOrder(orderId).then(function (order) {
        _this.order = order;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Order not found';
        console.error('Error loading order:', err);
      });
    },
    getPrimaryImage: function getPrimaryImage(product) {
      if (!product || !product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    formatStatus: function formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paypalButton_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paypalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paypalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_content_repository_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    adsense: __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default.a,
    sidebar: __WEBPACK_IMPORTED_MODULE_1__components_sidebar_vue___default.a,
    purchaseButton: __WEBPACK_IMPORTED_MODULE_3__components_purchaseButton_vue___default.a
  },
  data: function data() {
    return {
      content: ""
    };
  },

  computed: {
    ps: function ps() {
      return this.$store.getters.packagesBySport("2343a835-82ae-4b4b-bb50-689912b97571").filter(function (p) {
        return !p.special;
      });
    },
    packages: function packages() {
      var s = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.sports, ["sport", this.$route.params.sport.toUpperCase()]);
      if (s) return this.$store.getters.packagesBySport(s.id).filter(function (p) {
        return !p.special;
      });else return [];
    },
    sports: function sports() {
      return this.$store.state.sports;
    }
  },
  watch: {
    $route: function $route() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__data_content_repository_js__["a" /* default */].get(this.$route.params.sport.toUpperCase()).then(function (result) {
        _this.content = result[0].content;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4__data_content_repository_js__["a" /* default */].get(this.$route.params.sport.toUpperCase()).then(function (result) {
      _this2.content = result[0].content;
      return _this2.content;
    });
  },

  metaInfo: {
    title: this.$route && this.$route.params ? this.$route.params.sport.toUpperCase() + " Packages" : "Packages"
  }
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$store.dispatch('getStoredUser');
  },

  metaInfo: {
    title: 'Payment Success'
  }
};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository_js__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'sidebar': __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default.a
  },
  data: function data() {
    return {
      testimonial: ''
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  metaInfo: {
    title: 'Privacy Policy'
  }
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_product_repository__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ProductDetail',
  data: function data() {
    return {
      product: null,
      loading: false,
      error: null,
      selectedImage: null,
      selectedColor: null,
      selectedSize: null,
      quantity: 1,
      addedToCart: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['cartItemCount']), {
    isAuthenticated: function isAuthenticated() {
      return !!this.currentUser;
    },
    availableColors: function availableColors() {
      if (!this.product || !this.product.variants) return [];
      var colors = this.product.variants.filter(function (v) {
        return v.active === 1 && v.color;
      }).map(function (v) {
        return v.color;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(colors)));
    },
    availableSizes: function availableSizes() {
      if (!this.product || !this.product.variants) return [];
      var sizes = this.product.variants.filter(function (v) {
        return v.active === 1 && v.size;
      }).map(function (v) {
        return v.size;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(sizes)));
    },
    selectedVariant: function selectedVariant() {
      var _this = this;

      if (!this.product || !this.product.variants) return null;

      return this.product.variants.find(function (v) {
        var colorMatch = !_this.selectedColor || v.color === _this.selectedColor;
        var sizeMatch = !_this.selectedSize || v.size === _this.selectedSize;
        return v.active === 1 && colorMatch && sizeMatch;
      });
    },
    currentPrice: function currentPrice() {
      if (!this.product) return 0;

      if (this.product.is_on_sale && this.product.sale_price_cents !== null) {
        return this.product.sale_price_cents;
      }

      if (this.selectedVariant && this.selectedVariant.price_modifier_cents) {
        return this.product.base_price_cents + this.selectedVariant.price_modifier_cents;
      }

      return this.product.base_price_cents;
    },
    regularPrice: function regularPrice() {
      if (!this.product) return 0;

      if (this.selectedVariant && this.selectedVariant.price_modifier_cents) {
        return this.product.base_price_cents + this.selectedVariant.price_modifier_cents;
      }

      return this.product.base_price_cents;
    }
  }),
  mounted: function mounted() {
    this.loadProduct();
  },

  methods: {
    loadProduct: function loadProduct() {
      var _this2 = this;

      this.loading = true;
      this.error = null;

      var slug = this.$route.params.slug;

      __WEBPACK_IMPORTED_MODULE_4__data_product_repository__["a" /* default */].getBySlug(slug).then(function (product) {
        _this2.product = product;
        _this2.loading = false;

        if (product.images && product.images.length > 0) {
          _this2.selectedImage = product.images.find(function (img) {
            return img.is_primary === 1;
          }) || product.images[0];
        }

        if (_this2.availableColors.length > 0) {
          _this2.selectedColor = _this2.availableColors[0];
        }
        if (_this2.availableSizes.length > 0) {
          _this2.selectedSize = _this2.availableSizes[0];
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.error = 'Product not found';
        console.error('Error loading product:', err);
      });
    },
    addToCart: function addToCart() {
      if (!this.selectedVariant) {
        alert('Please select all options');
        return;
      }

      if (!this.isAuthenticated) {
        alert('Please log in or register before adding items to your cart.');
        this.$router.push('/register');
        return;
      }

      var cartItem = {
        variantId: this.selectedVariant.id,
        productId: this.product.id,
        quantity: this.quantity,
        price: this.currentPrice / 100,
        name: this.product.name,
        size: this.selectedVariant.size,
        color: this.selectedVariant.color,
        image: this.selectedImage ? this.selectedImage.image_url : null,
        isOnSale: this.product.is_on_sale || false
      };

      this.$store.dispatch('addToCart', cartItem);

      this.addedToCart = true;
    },
    incrementQuantity: function incrementQuantity() {
      this.quantity++;
    },
    decrementQuantity: function decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    }
  }
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_purchase_repository__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








/* harmony default export */ __webpack_exports__["default"] = {
  components: {},
  data: function data() {
    return {
      cardField: {},
      purchaseDisabled: false,
      errorMessage: ''
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    dataPackage: function dataPackage() {
      return this.getPackage();
    },
    buttonText: function buttonText() {
      return this.currentUser ? 'Purchase $' + this.dataPackage.current_price : 'Log in to Purchase';
    }
  },
  created: function created() {
    this.debouncedClick = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(this.purchase, 1000);
  },
  mounted: function mounted() {
    var _this = this;

    var _onApprove = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data, actions) {
        var that, response, orderData, purchaseUnit, payments, transaction, serverData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('onApproveCallback ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
                that = this;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__data_purchase_repository__["a" /* default */].capture(data);

              case 5:
                response = _context.sent;

                console.log(response);

                orderData = response.data;
                purchaseUnit = orderData.purchase_units && orderData.purchase_units[0] || null;
                payments = purchaseUnit ? purchaseUnit.payments : null;
                transaction = payments ? payments.captures && payments.captures[0] || payments.authorizations && payments.authorizations[0] : null;

                if (!(transaction && transaction.status === "DECLINED")) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt('return', _setErrorMessage('Your card was declined. Please try a different payment method.'));

              case 13:
                return _context.abrupt('return', _routeToSuccess());

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](2);

                console.log('error on approve');
                serverData = _context.t0.response && _context.t0.response.data;

                _setErrorMessage(serverData && (serverData.error || serverData.msg) || 'There was an issue processing your payment');

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16]]);
      }));

      return function _onApprove(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    var _createOrder = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
        var orderData, errorDetail, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (that.currentUser) {
                  _context2.next = 4;
                  break;
                }

                that.$root.$refs.toastr.w('Please log in or register to become a Premium Member');
                return _context2.abrupt('return', that.$router.push('/register'));

              case 4:
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__data_purchase_repository__["a" /* default */].create({
                  cart: [{
                    id: that.dataPackage.id,
                    quantity: 1,
                    price: that.dataPackage.current_price
                  }]
                });

              case 6:
                orderData = _context2.sent;

                if (!orderData.data.id) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return', orderData.data.id);

              case 11:
                errorDetail = orderData.data.details[0];
                errorMessage = errorDetail ? errorDetail.issue + ' ' + errorDetail.description + ' (' + orderData.data.debug_id + ')' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(orderData);


                _setErrorMessage(errorMessage);
                throw new Error(errorMessage);

              case 15:
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](0);

                console.log("error on purchase");
                that.errorMessage = "There was an issue processing your payment";
                console.error(_context2.t0);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 17]]);
      }));

      return function _createOrder(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    var that = this;

    function _routeToSuccess() {
      that.$router.push("/paymentsuccess");
    }
    function _setErrorMessage(message) {
      that.errorMessage = message;
    }
    this.$nextTick(function () {
      paypal.Buttons({
        createOrder: _createOrder,
        onApprove: _onApprove,
        onError: function onError(error) {
          console.error(error);
          this.errorMessage = error.message || "There was an issue processing your payment";
        },
        funding: {
          disallowed: [paypal.FUNDING.CREDIT]
        },

        style: {
          shape: "rect",
          layout: "vertical",
          color: "gold",
          label: "paypal"
        },
        message: {
          amount: 100
        }
      }).render("#paypal-button-container");
      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            "font-size": "16px",
            "font-family": "courier, monospace",
            "font-weight": "lighter",
            color: "#333333"
          },
          ".invalid": { color: "red" }
        }
      });
      console.log('IsEligible ' + that.cardField.isEligible());
      if (that.cardField.isEligible()) {
        var nameField = that.cardField.NameField();
        nameField.render("#card-name-field-container");
        console.log("render namefield");
        var numberField = that.cardField.NumberField();
        numberField.render("#card-number-field-container");
        var cvvField = that.cardField.CVVField({});
        cvvField.render("#card-cvv-field-container");
        var expiryField = that.cardField.ExpiryField({});
        expiryField.render("#card-expiry-field-container");
      } else {
        _this.errorMessage = "Card fields are not available at this time. Please reach out to support@stumpthespread.com";
      }
    });
  },

  methods: {
    getPackage: function getPackage() {
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.$store.state.currentPackage)) {
        return this.$store.state.currentPackage;
      } else if (this.$route.query.package) {
        var pack = this.$store.getters.package(this.$route.query.package);
        return pack ? pack : { id: "ALLMO", current_price: "129", name: "1 Month All Sports Package" };
      } else {
        return { id: "ALLMO", current_price: "129", name: "1 Month All Sports Package" };
      }
    },
    purchase: function purchase() {
      var _this2 = this;

      if (this.purchaseDisabled) return;
      if (!this.currentUser || !this.currentUser.id) {
        this.$root.$refs.toastr.w('Please log in or register to become a Premium Member');
        return this.$router.push('/register');
      }
      this.$nextTick(function () {
        _this2.purchaseDisabled = true;
      });
      this.cardField.submit({}).then(function (data) {
        console.log(data);
      }).catch(function (error) {
        if (error.message === "INVALID_NUMBER") {
          _this2.errorMessage = "Payment issue: Invalid card number";
        } else if (error.message === "INVALID_EXPIRY") {
          _this2.errorMessage = "Payment issue: Invalid expiration date";
        } else if (error.message === "INVALID_CVV") {
          _this2.errorMessage = "Payment issue: Invalid CVV";
        } else {
          _this2.errorMessage = "There was an issue processing your payment";
        }
        console.error(error);
      }).finally(function () {
        _this2.purchaseDisabled = false;
      });
    }
  }
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_purchaseButton_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_purchaseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_purchaseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    purchaseButton: __WEBPACK_IMPORTED_MODULE_0__components_purchaseButton_vue___default.a
  },
  data: function data() {
    return {
      registered: false,
      user: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        validateNumber: ""
      }
    };
  },

  computed: {
    ps: function ps() {
      return this.$store.getters.packagesBySport("2343a835-82ae-4b4b-bb50-689912b97571").filter(function (p) {
        return !p.special;
      });
    }
  },
  mounted: function mounted() {
    this.$refs.fname.focus();
    jQuery("#success-login").first().fancybox();
  },

  methods: {
    signup: function signup() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__["a" /* default */].register(_this.user).then(function (user) {
          _this.registered = true;
        }).catch(function (e) {
          if (e.response.data) {
            console.log(e.response.data);
            var str = "";
            if (e.response.data.errors) {
              __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forOwn(e.response.data.errors, function (value, key) {
                str += value.join(", ");
              });
            } else {
              str = e.response.data.message;
            }
            _this.$root.$refs.toastr.e(str);
          } else _this.$root.$refs.toastr.e(e);
        });
      });
    }
  },
  metaInfo: {
    title: "Register"
  }
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StsFooter__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StsFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StsFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StsHeader__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StsHeader__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    StsFooter: __WEBPACK_IMPORTED_MODULE_0__StsFooter___default.a,
    StsHeader: __WEBPACK_IMPORTED_MODULE_1__StsHeader___default.a
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.$store.dispatch("getStoredUser");
    this.$store.dispatch("getFreePicks");
    this.$store.dispatch("getSports");
    this.$store.dispatch("getPackages");
    this.$store.dispatch("getCategories");
  }
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Shop',
  data: function data() {
    return {
      loading: false,
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['products'])),
  mounted: function mounted() {
    this.loadProducts();
  },

  methods: {
    loadProducts: function loadProducts() {
      var _this = this;

      this.loading = true;
      this.error = null;

      this.$store.dispatch('getProducts').then(function () {
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Failed to load products. Please try again later.';
        console.error('Error loading products:', err);
      });
    },
    viewProduct: function viewProduct(product) {
      this.$router.push('/shop/' + product.slug);
    },
    primaryImage: function primaryImage(product) {
      if (!product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    truncateDescription: function truncateDescription(description) {
      if (!description) return '';
      return description.length > 100 ? description.substring(0, 100) + '...' : description;
    }
  }
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_post_repository_js__ = __webpack_require__(34);




/* harmony default export */ __webpack_exports__["default"] = {
  name: "StsFooter",
  components: {
    login: __WEBPACK_IMPORTED_MODULE_0__components_login___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      posts: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_post_repository_js__["a" /* default */].recent().then(function (res) {
      _this.posts = res;
    });
  }
};

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_testimonial_repository_js__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = {
  name: "StsHeader",
  data: function data() {
    return {
      testimonial: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["cartItemCount"]), {
    isHome: function isHome() {
      return this.$route.name === "home";
    },
    params: function params() {
      return this.$route.params;
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    bc: function bc() {
      return this.$breadcrumbs.slice(-1).pop();
    },
    pick: function pick() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(this.$store.state.picks) || {};
    }
  }),
  watch: {
    isHome: function isHome(val) {
      if (val) {
        this.$nextTick(function () {
          jQuery("#slider").cycle({
            timeout: 10000,
            pager: "#slider-nav",
            fx: "fade" });
          var module = document.getElementById("freePickContent");
          if (module) $clamp(module, { clamp: 3 });
        });
      }
    },
    pick: function pick(val) {
      if (val) {
        this.$nextTick(function () {
          var module = document.getElementById("freePickContent");
          if (module) $clamp(module, { clamp: 3 });
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    jQuery("#login-link").first().fancybox();
    jQuery(document).ready(function () {
      jQuery("#slider").cycle({
        timeout: 10000,
        pager: "#slider-nav",
        fx: "fade" });
    });
    __WEBPACK_IMPORTED_MODULE_3__data_testimonial_repository_js__["a" /* default */].getTestimonials(1).then(function (test) {
      _this.testimonial = test;
    });
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch("logout");
      if (this.$route.name === "myaccount" || this.$route.name === "changepassword" || this.$route.name === "picks") this.$router.push("/");
    }
  }
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    'sidebar': __WEBPACK_IMPORTED_MODULE_0__components_sidebar_vue___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },

  metaInfo: {
    title: 'Terms of Use'
  }
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    adsense: __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      testimonials: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository__["a" /* default */].getTestimonials().then(function (testimonials) {
      _this.testimonials = testimonials;
    });
  },

  metaInfo: {
    title: "Testimonials"
  }
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pick_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pick_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_pick_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_pick_repository_js__ = __webpack_require__(33);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    adsense: __WEBPACK_IMPORTED_MODULE_0__components_adsense_vue___default.a,
    pick: __WEBPACK_IMPORTED_MODULE_1__components_pick_vue___default.a
  },
  data: function data() {
    return {
      picks: null,
      selectedSport: "All"
    };
  },

  computed: {
    sportOptions: function sportOptions() {
      var _this = this;

      var seen = {};
      var options = ["All"];
      (this.picks || []).forEach(function (p) {
        var name = _this.sportName(p);
        if (!seen[name]) {
          seen[name] = true;
          options.push(name);
        }
      });
      return options;
    },
    filteredPicks: function filteredPicks() {
      var _this2 = this;

      if (!this.picks || this.selectedSport === "All") return this.picks || [];
      return this.picks.filter(function (p) {
        return _this2.sportName(p) === _this2.selectedSport;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2__data_pick_repository_js__["a" /* default */].getPremium().then(function (p) {
      _this3.picks = p;
    });
  },

  methods: {
    sportName: function sportName(pick) {
      return pick && pick.sport && pick.sport.sport || "Other";
    },
    sportLabel: function sportLabel(value) {
      if (value === "NCAAF") return "CFB";
      if (value === "NCAAB") return "CBB";
      return value;
    },
    selectSport: function selectSport(value) {
      this.selectedSport = value;
    }
  },
  metaInfo: {
    title: "View Picks"
  }
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_category_repository_js__ = __webpack_require__(41);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      cat: {}
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_0__data_category_repository_js__["a" /* default */].one(this.$route.params.id).then(function (category) {
        _this.cat = category;
      });
    }
  },

  methods: {
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_category_repository_js__["a" /* default */].save(this.cat).then(function (result) {
        _this2.$root.$refs.toastr.s("Category saved");
        _this2.$router.push("/admin");
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_package_repository_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      sports: this.$store.state.sports,
      sport: {},
      pack: {}
    };
  },
  created: function created() {
    if (this.$route.params.id) {
      this.pack = this.$store.getters.package(this.$route.params.id);
      this.sport = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.sports, ["id", this.pack.sports_id]);
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__data_package_repository_js__["a" /* default */].save(this.pack).then(function (result) {
        _this.$root.$refs.toastr.s("Result saved");
        _this.$router.push("/admin");
      }).catch(function () {
        return _this.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__ = __webpack_require__(34);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      post: {
        id: "",
        title: "",
        content: ""
      }
    };
  },

  computed: {
    categories: function categories() {
      return this.$store.state.categories;
    }
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].getOne(this.$route.params.id).then(function (p) {
        console.log("P is " + p);
        _this.post = p;
        _this.cat = p.category;
      });
    } else {
      this.cat = this.categories[0];
    }
  },

  methods: {
    save: function save() {
      var _this2 = this;

      this.post.category_id = this.cat.id;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].save(this.post).then(function (result) {
        _this2.$root.$refs.toastr.s("Post saved");
        _this2.$router.push("/admin");
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      sports: this.$store.state.sports,
      id: "",
      pick: "",
      side: "",
      risk: "",
      result: "",
      sport: ""
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].one(this.$route.params.id).then(function (record) {
        _this.id = record.record_id;
        _this.pick = record.pick;
        _this.side = record.side;
        _this.risk = record.risk;
        _this.result = record.result;
        _this.sport = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.sports, ["id", record.sports_id]);
      });
    }
  },

  methods: {
    save: function save() {
      var _this2 = this;

      var r = {
        record_id: this.id,
        pick: this.pick,
        side: this.side,
        risk: this.risk,
        result: this.result,
        sports_id: this.sport.id
      };
      __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].save(r).then(function (result) {
        _this2.$root.$refs.toastr.s("Result saved");
        _this2.$router.push("/admin");
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_user_repository_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_membership_repository_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);








/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      user: {},
      membership: undefined,
      password: "",
      originalPremium: "",
      MIN_PASSWORD_LENGTH: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* MIN_PASSWORD_LENGTH */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.user.id) return;
    __WEBPACK_IMPORTED_MODULE_3__data_membership_repository_js__["a" /* default */].get(this.user.id).then(function (result) {
      _this.membership = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(result) ? undefined : result;
    });
  },
  created: function created() {
    var storeUser = this.$store.getters.editUser();

    if (!storeUser || !storeUser.id) return this.$router.replace("/admin/users");

    this.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, storeUser);
    this.originalPremium = String(storeUser.premium);
  },

  methods: {
    save: function save() {
      var _this2 = this;

      if (this.password && this.password.length < __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* MIN_PASSWORD_LENGTH */]) return this.$root.$refs.toastr.e("Password must be at least " + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* MIN_PASSWORD_LENGTH */] + " characters");

      if (this.user.premium && !this.membership && this.premiumChanged()) return this.$root.$refs.toastr.e("Premium user must have membership");

      var changingPassword = !!this.password;
      var payload = changingPassword ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.user, { password: this.password }) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.user);

      __WEBPACK_IMPORTED_MODULE_2__data_user_repository_js__["a" /* default */].save(payload).then(function () {
        var memPromise = _this2.membership && _this2.user.premium ? __WEBPACK_IMPORTED_MODULE_3__data_membership_repository_js__["a" /* default */].save(_this2.membership) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
        return memPromise.then(function () {
          _this2.password = "";
          if (changingPassword) {
            _this2.$root.$refs.toastr.s("Password updated for " + _this2.user.email);
          } else {
            _this2.$root.$refs.toastr.s("User saved");
            _this2.$router.push("/admin");
          }
        });
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    },
    premiumChanged: function premiumChanged() {
      return this.originalPremium !== String(this.user.premium);
    },
    addMembership: function addMembership() {
      this.membership = {
        allsports_expire: new Date().toISOString().substring(0, 10),
        user_id: this.user.id
      };
    }
  }
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_category_repository_js__ = __webpack_require__(41);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      categories: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__data_category_repository_js__["a" /* default */].get().then(function (data) {
      _this.categories = data;
    });
  }
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  computed: {
    packages: function packages() {
      return this.$store.state.packages;
    }
  }
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      picks: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__["a" /* default */].getAll().then(function (picks) {
      console.log(picks);
      _this.picks = picks;
    });
  },

  methods: {
    remove: function remove(pick) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__["a" /* default */].remove(pick).then(function () {
        _this2.$root.$refs.toastr.s("Pick removed");
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this2.picks, pick);
      });
    }
  }
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      posts: [],
      total: 0,
      current: 0,
      page: 0
    };
  },

  computed: {
    hideMore: function hideMore() {
      return this.current >= this.total;
    }
  },
  created: function created() {
    this.next();
  },

  methods: {
    next: function next() {
      var _this = this;

      if (this.current >= this.total && this.page !== 0) return;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].get(this.page + 1).then(function (data) {
        _this.total = data.total;
        _this.current = data.to;
        _this.page = data.current_page;
        _this.posts = _this.posts.concat(data.data);
      });
    },
    remove: function remove(post) {
      var _this2 = this;

      post.active = false;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].save(post).then(function (result) {
        _this2.$root.$refs.toastr.s("Post removed");
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this2.posts, post);
      });
    }
  }
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_result_repository_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      total: 0,
      current: 0,
      page: 0,
      records: [],
      results: []
    };
  },

  computed: {
    hideMore: function hideMore() {
      return this.current >= this.total;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].get(this.page + 1).then(function (data) {
      _this.total = data.total;
      _this.current = data.to;
      _this.page = data.current_page;
      _this.records = data.data;
    });
    __WEBPACK_IMPORTED_MODULE_1__data_result_repository_js__["a" /* default */].get("overall").then(function (data) {
      _this.results = data;
    });
  },

  methods: {
    next: function next() {
      var _this2 = this;

      if (this.current >= this.total && this.page !== 0) return;
      __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].get(this.page + 1).then(function (data) {
        _this2.total = data.total;
        _this2.current = data.to;
        _this2.page = data.current_page;
        _this2.records = _this2.records.concat(data.data);
      });
    },
    remove: function remove(record) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].remove(record).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(_this3.records, record);
        _this3.$root.$refs.toastr.s("Record removed");
      }).catch(function () {
        return _this3.$root.$refs.toastr.e("An error occurred");
      });
    },
    update: function update(record, result) {
      var _this4 = this;

      record.result = result;
      __WEBPACK_IMPORTED_MODULE_0__data_record_repository_js__["a" /* default */].save(record).then(function (result) {
        _this4.$root.$refs.toastr.s("Result saved");
      }).catch(function () {
        return _this4.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      testimonials: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__["a" /* default */].getTestimonials().then(function (testimonials) {
      console.log(testimonials);
      _this.testimonials = testimonials;
    });
  },

  methods: {
    remove: function remove(testimonial) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__["a" /* default */].remove(testimonial).then(function (result) {
        _this2.$root.$refs.toastr.s("Testimonial removed");
        _this2.$router.push("/admin");
      });
    }
  }
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_prerender_repository__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_admin_repository__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_SearchableSelect__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_SearchableSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_SearchableSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__ = __webpack_require__(262);








/* harmony default export */ __webpack_exports__["default"] = {
  components: { SearchableSelect: __WEBPACK_IMPORTED_MODULE_4__components_admin_SearchableSelect___default.a },
  data: function data() {
    return {
      sports: this.$store.state.sports,
      betTypes: [{
        key: 0,
        value: "spread"
      }, {
        key: 1,
        value: "moneyline"
      }, {
        key: 2,
        value: "total"
      }],
      betSelection: [{
        key: 0,
        value: "home"
      }, {
        key: 1,
        value: "away"
      }, {
        key: 2,
        value: "over"
      }, {
        key: 3,
        value: "under"
      }, {
        key: 4,
        value: "draw"
      }, {
        key: 5,
        value: "none"
      }],
      games: [],
      payload: { games: [], oddsTypes: [], props: [] },
      categories: [],
      category: null,
      selectedRow: null,
      selectedPropGame: null,
      initialLabel: "",
      initialGameLabel: "",
      id: "",
      pickType: "Free",
      betType: { key: 1, value: "moneyline" },
      selection: { key: 0, value: "home" },
      sport: "MLB",
      spread: "",

      content: "",

      side: "",
      price: "",
      units: 1
    };
  },

  computed: {
    sideOptions: function sideOptions() {
      if (this.category && this.category.mode === "prop") {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["a" /* isYesNoProp */])(this.selectedRow)) {
          return [{ key: 0, value: "yes" }, { key: 1, value: "no" }];
        }
        return this.betSelection.filter(function (s) {
          return s.value === "over" || s.value === "under";
        });
      }
      return this.betSelection;
    },
    pick: function pick() {
      if (!this.selectedRow || !this.selection || !this.category) return "";
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["b" /* buildPickString */])(this.category.key, this.selectedRow, this.selection.value);
    }
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__["a" /* default */].getPick(this.$route.params.id).then(function (pick) {
        _this.id = pick.id;
        _this.sport = pick.sport;
        _this.price = pick.price;
        _this.units = pick.units;
        _this.side = pick.side;
        _this.content = pick.content;
        _this.pickType = pick.premium ? "Premium" : "Free";
        _this.pick = pick.pick;
        that.onChange().then(function () {
          var jid = pick.record ? pick.record.json_odds_id : null;
          var propType = pick.record ? pick.record.prop_type : null;
          var oddsType = pick.record && pick.record.odds_type ? pick.record.odds_type : "Game";

          if (propType) {
            that.category = that.categories.find(function (c) {
              return c.key === "Props";
            }) || that.categories[0];
          } else {
            that.category = that.categories.find(function (c) {
              return c.key === oddsType;
            }) || that.categories[0];
          }

          if (that.category) {
            that.selectedRow = that.category.rows.find(function (r) {
              return r.ID === jid;
            }) || null;
          }
          if (that.selectedRow) {
            if (that.category.mode === "prop") {
              that.selectedPropGame = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["c" /* propGames */])(that.payload).find(function (g) {
                return g.EventID === that.selectedRow.EventID;
              }) || null;
              if (that.selectedPropGame) {
                that.initialGameLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["d" /* rowLabel */])({ mode: "game" }, that.selectedPropGame);
              }
              that.initialLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["e" /* propRowLabel */])(that.selectedRow);
            } else {
              that.initialLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["d" /* rowLabel */])(that.category, that.selectedRow);
            }
            that.title = that.selectedRow.AwayTeam + " vs. " + that.selectedRow.HomeTeam;
            that.betType = that.betTypes.find(function (b) {
              return b.key === Number(pick.record.bet_type);
            });
            if (that.category.mode === "prop" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["a" /* isYesNoProp */])(that.selectedRow)) {
              that.selection = Number(pick.record.bet_selection) === 1 ? { key: 1, value: "no" } : { key: 0, value: "yes" };
            } else {
              that.selection = that.betSelection.find(function (s) {
                return s.key === Number(pick.record.bet_selection);
              });
            }
          }
        });
      });
    }
  },

  methods: {
    save: function save() {
      var _this2 = this;

      var row = this.selectedRow;
      var isProp = this.category && this.category.mode === "prop";
      var p = {
        id: this.id,
        title: row.AwayTeam + " vs. " + row.HomeTeam,
        content: this.content,
        sports_id: this.sport.id,
        price: this.price,
        units: this.units,
        side: this.side,
        date: row.MatchTime,
        premium: this.pickType === "Premium",
        pick: this.pick,
        bet_selection: this.selection.key,
        bet_type: this.betType.key,
        odds_id: row.ID,
        odds_type: isProp ? "Game" : this.category.key,
        prop_type: isProp ? row.PropType : null,
        participant: isProp && row.Participant ? row.Participant.Name : null
      };
      __WEBPACK_IMPORTED_MODULE_0__data_pick_repository__["a" /* default */].save(p).then(function () {
        _this2.$store.dispatch("getFreePicks");
        _this2.$root.$refs.toastr.s("Pick saved");
        _this2.$router.push("/admin");
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    },
    fillLine: function fillLine() {
      if (!this.selectedRow) return;
      var o = this.selectedRow.Odds && this.selectedRow.Odds[0] || {};

      if (this.category && this.category.mode === "prop") {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["a" /* isYesNoProp */])(this.selectedRow)) {
          this.side = "";
          this.price = this.selection.value === "no" ? o.MoneyLineAway : o.MoneyLineHome;
          return;
        }
        this.side = o.TotalNumber != null ? o.TotalNumber : "";
        this.price = this.selection.value === "under" ? o.UnderLine : o.OverLine;
        return;
      }

      var sel = this.selection.value;
      var bt = this.betType.value;
      if (sel === "home" && bt === "moneyline") {
        this.price = o.MoneyLineHome;
        this.side = "";
      }
      if (sel === "away" && bt === "moneyline") {
        this.price = o.MoneyLineAway;
        this.side = "";
      }
      if (sel === "away" && bt === "spread") {
        this.price = o.PointSpreadAwayLine;
        this.side = o.PointSpreadAway;
      }
      if (sel === "home" && bt === "spread") {
        this.price = o.PointSpreadHomeLine;
        this.side = o.PointSpreadHome;
      }
      if (sel === "over" && bt === "total") {
        this.price = o.OverLine;
        this.side = o.TotalNumber;
      }
      if (sel === "under" && bt === "total") {
        this.price = o.UnderLine;
        this.side = o.TotalNumber;
      }
    },
    onCategoryChange: function onCategoryChange() {
      this.selectedRow = null;
      this.selectedPropGame = null;
      this.initialLabel = "";
      this.initialGameLabel = "";
      this.side = "";
      this.price = "";
      if (this.category && this.category.mode === "prop") {
        this.betType = { key: 2, value: "total" };
        this.selection = { key: 2, value: "over" };
      } else {
        this.betType = { key: 1, value: "moneyline" };
        this.selection = { key: 0, value: "home" };
      }
    },
    onRowSelect: function onRowSelect(row) {
      this.selectedRow = row;
      if (this.category && this.category.mode === "prop") {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["a" /* isYesNoProp */])(row)) {
          this.betType = { key: 1, value: "moneyline" };
          this.selection = { key: 0, value: "yes" };
        } else {
          this.betType = { key: 2, value: "total" };
          this.selection = { key: 2, value: "over" };
        }
      }
      this.fillLine();
    },
    filterFn: function filterFn(query) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["f" /* filterRows */])(this.category, query);
    },
    rowLabelFn: function rowLabelFn(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["d" /* rowLabel */])(this.category, row);
    },
    rowKeyFn: function rowKeyFn(row) {
      return row.ID;
    },
    filterPropGamesFn: function filterPropGamesFn(query) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["f" /* filterRows */])({ mode: "game", rows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["c" /* propGames */])(this.payload) }, query);
    },
    propGameLabelFn: function propGameLabelFn(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["d" /* rowLabel */])({ mode: "game" }, row);
    },
    onPropGameSelect: function onPropGameSelect(game) {
      this.selectedPropGame = game;
      this.selectedRow = null;
      this.initialLabel = "";
      this.side = "";
      this.price = "";
    },
    filterPropsFn: function filterPropsFn(query) {
      var rows = this.selectedPropGame ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["g" /* propsForGame */])(this.payload, this.selectedPropGame.EventID) : [];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["h" /* filterPropsInGame */])(rows, query);
    },
    propLabelFn: function propLabelFn(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["e" /* propRowLabel */])(row);
    },
    onChange: function onChange() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2__data_admin_repository__["a" /* default */].getGames(this.sport.sport.toLowerCase()).then(function (d) {
        var norm = function norm(rows) {
          return (rows || []).forEach(function (g) {
            g.MatchTime = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(g.MatchTime).local().format("YYYY-MM-DD");
          });
        };
        norm(d.games);
        (d.oddsTypes || []).forEach(function (ot) {
          return norm(ot.games);
        });
        norm(d.props);

        _this3.payload = d;
        _this3.categories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_oddsCategories__["i" /* buildCategories */])(d);
        _this3.category = _this3.categories[0] || null;
        _this3.selectedRow = null;
        _this3.selectedPropGame = null;
        _this3.initialLabel = "";
        _this3.initialGameLabel = "";
        _this3.betType = { key: 1, value: "moneyline" };
        _this3.selection = { key: 0, value: "home" };
        _this3.side = "";
        _this3.price = "";
        return d;
      });
    }
  }
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      title: "",
      testimonial: {
        id: "",
        content: "",
        author: "",
        type: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__["a" /* default */].get(this.$route.params.id).then(function (test) {
        _this.testimonial.id = test.id;
        _this.testimonial.content = test.content;
        _this.testimonial.author = test.author;
        _this.testimonial.type = test.type;
        _this.title = "Edit Testimonial";
      });
    } else this.title = "Add Testimonial";
  },

  methods: {
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_testimonial_repository__["a" /* default */].save(this.testimonial).then(function (result) {
        _this2.$root.$refs.toastr.s("Testimonial saved");
        _this2.$router.push("/admin");
      }).catch(function () {
        return _this2.$root.$refs.toastr.e("An error occurred");
      });
    }
  }
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_user_repository__ = __webpack_require__(73);



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      email: "",
      users: []
    };
  },

  methods: {
    searchUsers: function searchUsers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__data_user_repository__["a" /* default */].searchByEmail(this.email).then(function (data) {
        _this.users = data;
      });
    },
    editUser: function editUser(user) {
      this.$store.state.editUser = user;
      this.$router.push({ path: "/admin/users/edit" });
    }
  }
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_tool_repository_js__ = __webpack_require__(267);






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    adsense: __WEBPACK_IMPORTED_MODULE_1__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      multipliers: ["Conservative", "Standard", "Aggressive"],
      selectedMultiplier: "Standard",
      bankroll: 1000,
      odds: "-150",
      edge: "5",
      optimal: { betSize: 0, percentage: 0 }
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    showOptimalBetSize: function showOptimalBetSize() {
      console.log("updating optimal bet size ", this.optimal.betSize);
      console.log(this.optimal.betSize > 0);
      return this.optimal.betSize > 0;
    }
  },
  methods: {
    calculate: function calculate() {
      var _this = this;

      if (!this.currentUser || !this.currentUser.id) {
        this.$root.$refs.toastr.w('Please log in or register to use the bet calculator');
        return;
      }
      return this.$validator.validateAll().then(function (result) {
        if (result) {
          var multiplier = _this.multipliers.indexOf(_this.selectedMultiplier);
          return __WEBPACK_IMPORTED_MODULE_2__data_tool_repository_js__["a" /* default */].size({ bankroll: _this.bankroll, line: Number(_this.odds), edge: _this.edge / 100, multiplier: multiplier }).then(function (response) {
            _this.optimal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.optimal, { betSize: response.optimal_bet, percentage: response.optimal_percentage });
            console.log(_this.optimal.betSize);
          });
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    multiplierChange: function multiplierChange() {
      this.optimal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.optimal, { betSize: 0, percentage: 0 });
    }
  }
};

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 93,
	"./af.js": 93,
	"./ar": 100,
	"./ar-dz": 94,
	"./ar-dz.js": 94,
	"./ar-kw": 95,
	"./ar-kw.js": 95,
	"./ar-ly": 96,
	"./ar-ly.js": 96,
	"./ar-ma": 97,
	"./ar-ma.js": 97,
	"./ar-sa": 98,
	"./ar-sa.js": 98,
	"./ar-tn": 99,
	"./ar-tn.js": 99,
	"./ar.js": 100,
	"./az": 101,
	"./az.js": 101,
	"./be": 102,
	"./be.js": 102,
	"./bg": 103,
	"./bg.js": 103,
	"./bm": 104,
	"./bm.js": 104,
	"./bn": 105,
	"./bn.js": 105,
	"./bo": 106,
	"./bo.js": 106,
	"./br": 107,
	"./br.js": 107,
	"./bs": 108,
	"./bs.js": 108,
	"./ca": 109,
	"./ca.js": 109,
	"./cs": 110,
	"./cs.js": 110,
	"./cv": 111,
	"./cv.js": 111,
	"./cy": 112,
	"./cy.js": 112,
	"./da": 113,
	"./da.js": 113,
	"./de": 116,
	"./de-at": 114,
	"./de-at.js": 114,
	"./de-ch": 115,
	"./de-ch.js": 115,
	"./de.js": 116,
	"./dv": 117,
	"./dv.js": 117,
	"./el": 118,
	"./el.js": 118,
	"./en-au": 119,
	"./en-au.js": 119,
	"./en-ca": 120,
	"./en-ca.js": 120,
	"./en-gb": 121,
	"./en-gb.js": 121,
	"./en-ie": 122,
	"./en-ie.js": 122,
	"./en-il": 123,
	"./en-il.js": 123,
	"./en-in": 124,
	"./en-in.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./en-sg": 126,
	"./en-sg.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 130,
	"./es-do": 128,
	"./es-do.js": 128,
	"./es-us": 129,
	"./es-us.js": 129,
	"./es.js": 130,
	"./et": 131,
	"./et.js": 131,
	"./eu": 132,
	"./eu.js": 132,
	"./fa": 133,
	"./fa.js": 133,
	"./fi": 134,
	"./fi.js": 134,
	"./fil": 135,
	"./fil.js": 135,
	"./fo": 136,
	"./fo.js": 136,
	"./fr": 139,
	"./fr-ca": 137,
	"./fr-ca.js": 137,
	"./fr-ch": 138,
	"./fr-ch.js": 138,
	"./fr.js": 139,
	"./fy": 140,
	"./fy.js": 140,
	"./ga": 141,
	"./ga.js": 141,
	"./gd": 142,
	"./gd.js": 142,
	"./gl": 143,
	"./gl.js": 143,
	"./gom-deva": 144,
	"./gom-deva.js": 144,
	"./gom-latn": 145,
	"./gom-latn.js": 145,
	"./gu": 146,
	"./gu.js": 146,
	"./he": 147,
	"./he.js": 147,
	"./hi": 148,
	"./hi.js": 148,
	"./hr": 149,
	"./hr.js": 149,
	"./hu": 150,
	"./hu.js": 150,
	"./hy-am": 151,
	"./hy-am.js": 151,
	"./id": 152,
	"./id.js": 152,
	"./is": 153,
	"./is.js": 153,
	"./it": 155,
	"./it-ch": 154,
	"./it-ch.js": 154,
	"./it.js": 155,
	"./ja": 156,
	"./ja.js": 156,
	"./jv": 157,
	"./jv.js": 157,
	"./ka": 158,
	"./ka.js": 158,
	"./kk": 159,
	"./kk.js": 159,
	"./km": 160,
	"./km.js": 160,
	"./kn": 161,
	"./kn.js": 161,
	"./ko": 162,
	"./ko.js": 162,
	"./ku": 163,
	"./ku.js": 163,
	"./ky": 164,
	"./ky.js": 164,
	"./lb": 165,
	"./lb.js": 165,
	"./lo": 166,
	"./lo.js": 166,
	"./lt": 167,
	"./lt.js": 167,
	"./lv": 168,
	"./lv.js": 168,
	"./me": 169,
	"./me.js": 169,
	"./mi": 170,
	"./mi.js": 170,
	"./mk": 171,
	"./mk.js": 171,
	"./ml": 172,
	"./ml.js": 172,
	"./mn": 173,
	"./mn.js": 173,
	"./mr": 174,
	"./mr.js": 174,
	"./ms": 176,
	"./ms-my": 175,
	"./ms-my.js": 175,
	"./ms.js": 176,
	"./mt": 177,
	"./mt.js": 177,
	"./my": 178,
	"./my.js": 178,
	"./nb": 179,
	"./nb.js": 179,
	"./ne": 180,
	"./ne.js": 180,
	"./nl": 182,
	"./nl-be": 181,
	"./nl-be.js": 181,
	"./nl.js": 182,
	"./nn": 183,
	"./nn.js": 183,
	"./oc-lnc": 184,
	"./oc-lnc.js": 184,
	"./pa-in": 185,
	"./pa-in.js": 185,
	"./pl": 186,
	"./pl.js": 186,
	"./pt": 188,
	"./pt-br": 187,
	"./pt-br.js": 187,
	"./pt.js": 188,
	"./ro": 189,
	"./ro.js": 189,
	"./ru": 190,
	"./ru.js": 190,
	"./sd": 191,
	"./sd.js": 191,
	"./se": 192,
	"./se.js": 192,
	"./si": 193,
	"./si.js": 193,
	"./sk": 194,
	"./sk.js": 194,
	"./sl": 195,
	"./sl.js": 195,
	"./sq": 196,
	"./sq.js": 196,
	"./sr": 198,
	"./sr-cyrl": 197,
	"./sr-cyrl.js": 197,
	"./sr.js": 198,
	"./ss": 199,
	"./ss.js": 199,
	"./sv": 200,
	"./sv.js": 200,
	"./sw": 201,
	"./sw.js": 201,
	"./ta": 202,
	"./ta.js": 202,
	"./te": 203,
	"./te.js": 203,
	"./tet": 204,
	"./tet.js": 204,
	"./tg": 205,
	"./tg.js": 205,
	"./th": 206,
	"./th.js": 206,
	"./tk": 207,
	"./tk.js": 207,
	"./tl-ph": 208,
	"./tl-ph.js": 208,
	"./tlh": 209,
	"./tlh.js": 209,
	"./tr": 210,
	"./tr.js": 210,
	"./tzl": 211,
	"./tzl.js": 211,
	"./tzm": 213,
	"./tzm-latn": 212,
	"./tzm-latn.js": 212,
	"./tzm.js": 213,
	"./ug-cn": 214,
	"./ug-cn.js": 214,
	"./uk": 215,
	"./uk.js": 215,
	"./ur": 216,
	"./ur.js": 216,
	"./uz": 218,
	"./uz-latn": 217,
	"./uz-latn.js": 217,
	"./uz.js": 218,
	"./vi": 219,
	"./vi.js": 219,
	"./x-pseudo": 220,
	"./x-pseudo.js": 220,
	"./yo": 221,
	"./yo.js": 221,
	"./zh-cn": 222,
	"./zh-cn.js": 222,
	"./zh-hk": 223,
	"./zh-hk.js": 223,
	"./zh-mo": 224,
	"./zh-mo.js": 224,
	"./zh-tw": 225,
	"./zh-tw.js": 225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;


/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-1bb071f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  "data-v-5663d85f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  "data-v-5f6234c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-1d9a3f1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  "data-v-456c9b9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-1854da36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-616229c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  "data-v-6e0e6596",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  "data-v-9a6b21d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  "data-v-4e2e808c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  "data-v-047bcdd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-14dedf48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-280e1dd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-05fd5457",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-55e21aab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-5d0ea5ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  "data-v-bc681a88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-e3fc4ad2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-758b1e04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-3ee64516",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  "data-v-c770e80a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  "data-v-b72dd6c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  "data-v-6cf191b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  "data-v-30742070",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  "data-v-e470f43a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  "data-v-a20c2c56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  "data-v-501ec206",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-69ac242e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  "data-v-74a7c77a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-714b663c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-d2dfe3dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  "data-v-0bfb8d84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  "data-v-058ebdb5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  "data-v-620b59a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  "data-v-951970ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  "data-v-0a00d8a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  "data-v-af1b867a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  "data-v-75789ba4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  "data-v-5bda5260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-40de4fb0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  "data-v-333ff54a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-59438b56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  "data-v-532c95be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-2e5a1731",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h5', [_vm._v("Forgot Password?")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter an email\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "name": "formforgotpw"
    }
  }, [_c('p', [_vm._v("Enter Email Address: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Reset Password"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success-box",
    attrs: {
      "id": "success"
    }
  }, [_vm._v("\n        Password reset has been sent! "), _c('span', {
    staticClass: "close"
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Check your email for the new password. Please be sure to check your spam folder. ")]), _vm._v(" "), _c('p', [_vm._v("Please contact support@stumpthespread if you have forgotten your login id.")])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Record")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Sport:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sport),
      expression: "sport"
    }],
    on: {
      "change": function($event) {
        _vm.sport = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.sports), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": s
      }
    }, [_vm._v("\n                  " + _vm._s(s.sport) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Pick:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pick),
      expression: "pick"
    }],
    attrs: {
      "type": "text",
      "name": "pick",
      "size": "33",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.pick)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pick = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Side:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.side),
      expression: "side"
    }],
    attrs: {
      "type": "text",
      "name": "side",
      "size": "10",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.side)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.side = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Risk:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.risk),
      expression: "risk"
    }],
    attrs: {
      "type": "text",
      "name": "risk",
      "size": "5",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.risk)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.risk = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Result:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.result),
      expression: "result"
    }],
    attrs: {
      "type": "text",
      "name": "result",
      "size": "3",
      "maxlength": "1"
    },
    domProps: {
      "value": _vm._s(_vm.result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.result = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit Record"
    }
  })])
}]}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.user) ? _c('h4', [_vm._v("\n        Welcome,   " + _vm._s(_vm.user.email) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n        Membership Type:\n        "), _c('b', [_vm._v(_vm._s(_vm.user && _vm.user.premium ? "Premium" : "Free"))])]), _vm._v(" "), (_vm.user && _vm.user.premium) ? _c('div', [_c('p', [_vm._v("\n          Email: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("\n          Pick Notifications:\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyEmail),
      expression: "notifyEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyEmail) ? _vm._i(_vm.notifyEmail, null) > -1 : (_vm.notifyEmail)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyEmail = $$c
        }
      }
    }
  }), _vm._v("\n            Email\n          ")]), _vm._v(" "), (_vm.notifyEmail) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Contact Email"
    },
    domProps: {
      "value": _vm._s(_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyPush),
      expression: "notifyPush"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyPush) ? _vm._i(_vm.notifyPush, null) > -1 : (_vm.notifyPush)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifyPush,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyPush = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyPush = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyPush = $$c
        }
      }
    }
  }), _vm._v("\n            Push Notification\n          ")]), _vm._v(" "), (_vm.notifyPush) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#666",
      "margin": "4px 0 0 24px"
    }
  }, [_vm._v("\n            Visit "), _c('a', {
    staticStyle: {
      "color": "#e94560"
    },
    attrs: {
      "href": "https://m.stumpthespread.com/myaccount",
      "target": "_blank"
    }
  }, [_vm._v("StumptheSpread.com/myaccount")]), _vm._v(" on your phone to set up push notifications.\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.user.notify_sms || _vm.user.contact_method === 2) ? _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifySms),
      expression: "notifySms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifySms) ? _vm._i(_vm.notifySms, null) > -1 : (_vm.notifySms)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.notifySms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifySms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifySms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifySms = $$c
        }
      }
    }
  }), _vm._v("\n            Text Message\n          ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#999",
      "margin-left": "4px"
    }
  }, [_vm._v("(no longer available for new sign-ups — please use Push Notifications instead)")]), _vm._v(" "), (_vm.notifySms) ? _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "id": "phoneList",
      "name": "phones"
    },
    on: {
      "change": function($event) {
        _vm.phone = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.phoneOpts), function(p) {
    return _c('option', {
      key: p.value,
      domProps: {
        "value": p
      }
    }, [_vm._v("\n                " + _vm._s(p.key) + "\n              ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Contact Phone"
    },
    domProps: {
      "value": _vm._s(_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n        Upgrade\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.premium) ? _c('button', {
    staticClass: "big-btn orange",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("\n        Update\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/changepassword'
      }
    }
  }, [_vm._v("\n        Change Password\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Manage Packages")]), _vm._v(" "), _vm._l((_vm.packages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "post full-width"
    }, [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v("\n           \n        "), _c('b', [_vm._v("$" + _vm._s(item.current_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "sml-btn blue",
      attrs: {
        "to": {
          path: '/admin/package/' + item.id
        }
      }
    }, [_vm._v("\n          Edit\n        ")])], 1)
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Category:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cat),
      expression: "cat"
    }],
    attrs: {
      "name": "categorydropdown"
    },
    on: {
      "change": function($event) {
        _vm.cat = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c
      }
    }, [_vm._v("\n                  " + _vm._s(c.category) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Title:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.title),
      expression: "post.title"
    }],
    attrs: {
      "type": "text",
      "name": "title",
      "size": "66",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.post.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Content:\n            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.content),
      expression: "post.content"
    }],
    attrs: {
      "name": "content",
      "cols": "50",
      "rows": "20"
    },
    domProps: {
      "value": _vm._s(_vm.post.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.content = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit Post"
    }
  })])
}]}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.picks), function(p) {
    return _c('pick', {
      key: p.id,
      attrs: {
        "pick": p
      }
    })
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('div', [_c('p', [_vm._v("\n          There are no picks currently posted. To receive picks immediately\n          when they are posted, please set up pick notifications in the\n          "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n            my account section (premium members only).\n          ")])], 1), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7567805932",
      "ad-layout-key": "-71-1m-75+i4+5r",
      "ad-format": "fluid"
    }
  })], 2), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "target": "_top"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "hspace": "0",
      "vspace": "0",
      "border": "0",
      "alt": "Bet at Betanysports.eu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Get the lowest juice at BetOnline,\n          "), _c('a', {
    attrs: {
      "href": "https://record.commission.bz/_k86Ic18Yvp1qkvbhkiKqDGNd7ZgqdRLk/1/",
      "target": "_blank"
    }
  }, [_vm._v("sign up here and receive a 50% bonus!")])])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('oldpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter your current password\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('New Password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('New Password')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('repeatpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please repeat password\n        ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('form', {
    attrs: {
      "name": "formcpw"
    }
  }, [_c('p', [_vm._v("\n          Current Password:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "password",
      "name": "oldpassword"
    },
    domProps: {
      "value": _vm._s(_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("New Password: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:repeatpassword'),
      expression: "'min:8|required|confirmed:repeatpassword'"
    }],
    attrs: {
      "type": "password",
      "name": "New Password",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Confirm Password: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "password",
      "name": "repeatpassword",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn blue",
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Update Password"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  })])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('p', [_vm._v(_vm._s(_vm.test.content))]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(_vm.test.author)), _c('b', [_vm._v(", " + _vm._s(_vm.test.type))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Testimonial")])])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchable-select",
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "down", 40)) { return; }
        $event.preventDefault();
        _vm.move(1)
      }, function($event) {
        if (_vm._k($event.keyCode, "up", 38)) { return; }
        $event.preventDefault();
        _vm.move(-1)
      }, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.choose(_vm.highlighted)
      }, function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.close($event)
      }]
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm._s(_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.open = true
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, function($event) {
        _vm.open = true;
        _vm.highlight = 0
      }]
    }
  }), _vm._v(" "), (_vm.open && _vm.rows.length) ? _c('ul', {
    staticClass: "ss-list"
  }, _vm._l((_vm.rows), function(row, i) {
    return _c('li', {
      key: _vm.rowKey(row) + '-' + i,
      class: {
        'ss-active': i === _vm.highlight
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.choose(row)
        },
        "mouseover": function($event) {
          _vm.highlight = i
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.rowLabelFn(row)) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), (_vm.open && !_vm.rows.length) ? _c('div', {
    staticClass: "ss-empty"
  }, [_vm._v("\n    No matches\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "category"
    }, [_vm._v(_vm._s(post.category.category))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    })])
  }), _vm._v(" "), (!_vm.hideMore) ? _c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n        More ->\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.categories), function(cat) {
    return _c('li', {
      key: cat.id
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.catClick(cat)
        }
      }
    }, [_vm._v(_vm._s(cat.category))])])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.archives), function(archive) {
    return _c('li', {
      key: archive.id
    }, [_c('a', {
      attrs: {
        "href": ";javascript"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.archiveClick(archive)
        }
      }
    }, [_vm._v(_vm._s(archive.month + " " + archive.year))])])
  }))])]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9157837875",
      "ad-style": "display:inline-block;width:160px;height:600px",
      "ad-format": "auto"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Archives")])])
}]}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [(_vm.testimonial) ? _c('testimonial', {
    attrs: {
      "test": _vm.testimonial
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('li', {
      key: p.id,
      staticClass: "widget"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h5', [_vm._v(_vm._s(p.name))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(p.name))]), _vm._v(" "), (p.current_price !== p.previous_price) ? _c('li', [_c('strike', [_vm._v("$" + _vm._s(p.previous_price))])], 1) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("$" + _vm._s(p.current_price))]), _vm._v(" "), _c('li', {
      staticStyle: {
        "margin-left": "-8px",
        "padding-top": "10px"
      }
    }, [_c('purchase-button', {
      attrs: {
        "package": p
      }
    })], 1)])])])
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "hosting-plans"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "plan"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside"
  }, [_vm._v("\n              $" + _vm._s(_vm.allWeekPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/week")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allWeek,
      "color": "grey"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "plan"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside"
  }, [_vm._v("\n              $" + _vm._s(_vm.allTwoPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/2 weeks")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allTwo,
      "color": "yellow"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "plan no-margin"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside1"
  }, [_vm._v("\n              $" + _vm._s(_vm.allMonthPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/month")])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allMonth,
      "color": "blue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "home-colums"
    }
  }, [_c('div', {
    staticClass: "colum"
  }, [_c('h3', [_vm._v("Sports Picks")]), _vm._v(" "), _c('p', [_vm._v("\n            Welcome to Stumpthespread.com. STS is home to expert sports\n            betting picks with over a decade in the industry. We offer a daily\n            1 unit free pick bet and anaylsis which is enjoyed by thousands of\n            our committed members in our free pick area. For those looking to\n            take their profits to the next level we recommend trying out an\n            All-Sport Premium memberships or a Full-Season sport specific\n            package. We offer numerous sports pick packages for our diverse\n            cross-section of users from the NFL, NBA, MLB, NHL, NCAAF, and\n            NCAAB. We're committed to providing our members with high quality\n            matchup analysis and our take on the top leans of the day for\n            picks against the spread, straight up, and over/unders. Consider\n            joining our team by becoming a free or premium member today\n            through a hassle free registration!\n          ")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: 'packages/all'
      }
    }
  }, [_vm._v("\n              Learn More\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "colum"
  }, [_c('h3', [_vm._v("Why Us ?")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "services-list"
    }
  }, [_vm._m(6), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sprite chart_bar icon"
  }), _vm._v("\n              " + _vm._s(_vm.count) + " members and counting!\n            ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9391510273",
      "ad-style": "display:inline-block;width:180px;height:150px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "colum no-margin"
  }, [_c('h3', [_vm._v("Happy Customers")]), _vm._v(" "), (_vm.testimonial) ? _c('blockquote', [_c('div', {
    staticClass: "image sprite me2 alignleft"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.testimonial.content))]), _vm._v(" "), _c('div', {
    staticClass: "sprite testimony-bg"
  }), _vm._v(" "), _c('cite', [_vm._v(_vm._s(_vm.testimonial.author) + ",  "), _c('b', [_vm._v(_vm._s(_vm.testimonial.type))])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("\n            More Testimonials\n          ")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9391510273",
      "ad-style": "display:inline-block;width:180px;height:150px",
      "ad-format": "auto"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("1 Week of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1 Week")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports Included!")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("2 Weeks of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("2 Weeks")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports Covered")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("1 Month of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Best Value")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports are Covered")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite coins icon"
  }), _vm._v("\n              High quality premium picks\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite iphone icon"
  }), _vm._v("\n              Access picks on smartphones and tablets\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite headphone icon"
  }), _vm._v("\n              Excellent customer service!\n            ")])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Bet Sizing Calculator")]), _vm._v(" "), _c('div', {
    staticClass: "two-column"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('bankroll')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n              Please enter a bankroll\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('odds')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('odds')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('edge')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('edge')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "bankroll"
    }
  }, [_vm._v("Bankroll:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankroll),
      expression: "bankroll"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "bankroll",
    attrs: {
      "type": "number",
      "name": "bankroll"
    },
    domProps: {
      "value": _vm._s(_vm.bankroll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankroll = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "odds"
    }
  }, [_vm._v("American Odds:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odds),
      expression: "odds"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|american_odds'),
      expression: "'required|american_odds'"
    }],
    ref: "odds",
    attrs: {
      "type": "text",
      "name": "odds",
      "data-vv-delay": "4000"
    },
    domProps: {
      "value": _vm._s(_vm.odds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odds = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "risk"
    }
  }, [_vm._v("Edge %:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edge),
      expression: "edge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    ref: "edge",
    attrs: {
      "type": "number",
      "name": "edge"
    },
    domProps: {
      "value": _vm._s(_vm.edge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group"
  }, _vm._l((_vm.multipliers), function(multiplier) {
    return _c('div', {
      key: multiplier
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMultiplier),
        expression: "selectedMultiplier"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": multiplier,
        "checked": _vm._q(_vm.selectedMultiplier, multiplier)
      },
      on: {
        "change": _vm.multiplierChange,
        "click": function($event) {
          _vm.selectedMultiplier = multiplier
        }
      }
    }), _vm._v("\n                    " + _vm._s(multiplier) + "\n                  ")])])
  }))]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "type": "submit",
      "value": "Calculate Optimal Bet Size",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.calculate($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column",
    staticStyle: {
      "min-width": "100px"
    }
  }, [(_vm.showOptimalBetSize) ? _c('h4', [_vm._v("\n            Optimal Bet Size: $" + _vm._s(_vm.optimal.betSize) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', [_vm._v("\n            It is recommended that you bet approximately "), _c('b', [_vm._v(_vm._s(_vm.optimal.percentage))]), _vm._v(" of your bankroll on this particular selection.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', [_c('b', [_vm._v("Note:")]), _vm._v(" This is a general recommendation for " + _vm._s(_vm.selectedMultiplier) + " bet sizing and should be adjusted based on your own risk tolerance and confidence in the selection.\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat,
      "data-ad-layout-key": _vm.adLayoutKey
    }
  })
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "picks-notice"
  }, [_c('p', [_vm._v("\n        Looking to purchase picks?\n        "), _c('router-link', {
    attrs: {
      "to": "/packages/all"
    }
  }, [_vm._v("\n          Click here to Buy Premium Picks!\n        ")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading products...\n    ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : (_vm.products.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("No products available at the moment.")])]) : _c('div', {
    staticClass: "product-grid"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "product-card",
      on: {
        "click": function($event) {
          _vm.viewProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "product-image"
    }, [(product.is_on_sale) ? _c('div', {
      staticClass: "sale-badge"
    }, [_vm._v("\n            SALE\n          ")]) : _vm._e(), _vm._v(" "), (_vm.primaryImage(product)) ? _c('img', {
      attrs: {
        "src": _vm.primaryImage(product).image_url,
        "alt": product.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("\n            No Image\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('h3', {
      staticClass: "product-name"
    }, [_vm._v("\n            " + _vm._s(product.name) + "\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "product-description"
    }, [_vm._v("\n            " + _vm._s(_vm.truncateDescription(product.description)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "product-footer"
    }, [_c('div', {
      staticClass: "price-container"
    }, [(product.is_on_sale) ? _c('span', {
      staticClass: "product-price-regular"
    }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(product.base_price_cents)) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "product-price",
      class: {
        'product-price-sale': product.is_on_sale
      }
    }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(product.is_on_sale ? product.sale_price_cents : product.base_price_cents)) + "\n              ")]), _vm._v(" "), (product.is_on_sale && product.discount_percentage) ? _c('span', {
      staticClass: "discount-badge"
    }, [_vm._v("\n                -" + _vm._s(product.discount_percentage) + "%\n              ")]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn-view"
    }, [_vm._v("\n              View Details\n            ")])])])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Add Pick")]), _vm._v(" "), _c('form', [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Pick Type:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickType),
      expression: "pickType"
    }],
    attrs: {
      "name": "freedropdown"
    },
    on: {
      "change": function($event) {
        _vm.pickType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("Free")]), _vm._v(" "), _c('option', [_vm._v("Premium")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Sport:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sport),
      expression: "sport"
    }],
    on: {
      "change": [function($event) {
        _vm.sport = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.onChange($event)
      }]
    }
  }, _vm._l((_vm.sports), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": s
      }
    }, [_vm._v("\n                  " + _vm._s(s.sport) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Category:")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    on: {
      "change": [function($event) {
        _vm.category = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.onCategoryChange()
      }]
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', {
      key: c.key,
      domProps: {
        "value": c
      }
    }, [_vm._v("\n                  " + _vm._s(c.label) + "\n                ")])
  }))])]), _vm._v(" "), (_vm.category && _vm.category.mode !== 'prop') ? _c('tr', [_c('td', [_vm._v("Game:")]), _vm._v(" "), _c('td', [_c('searchable-select', {
    key: _vm.category.key,
    attrs: {
      "filter-fn": _vm.filterFn,
      "row-label-fn": _vm.rowLabelFn,
      "row-key": _vm.rowKeyFn,
      "initial-label": _vm.initialLabel,
      "placeholder": "Search team…"
    },
    on: {
      "select": _vm.onRowSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.category && _vm.category.mode === 'prop') ? _c('tr', [_c('td', [_vm._v("Game:")]), _vm._v(" "), _c('td', [_c('searchable-select', {
    key: "prop-game",
    attrs: {
      "filter-fn": _vm.filterPropGamesFn,
      "row-label-fn": _vm.propGameLabelFn,
      "row-key": _vm.rowKeyFn,
      "initial-label": _vm.initialGameLabel,
      "placeholder": "Search team…"
    },
    on: {
      "select": _vm.onPropGameSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.category && _vm.category.mode === 'prop' && _vm.selectedPropGame) ? _c('tr', [_c('td', [_vm._v("Prop:")]), _vm._v(" "), _c('td', [_c('searchable-select', {
    key: 'prop-' + _vm.selectedPropGame.EventID,
    attrs: {
      "filter-fn": _vm.filterPropsFn,
      "row-label-fn": _vm.propLabelFn,
      "row-key": _vm.rowKeyFn,
      "initial-label": _vm.initialLabel,
      "placeholder": "Search player or prop…"
    },
    on: {
      "select": _vm.onRowSelect
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Pick Type:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.betType),
      expression: "betType"
    }],
    on: {
      "change": [function($event) {
        _vm.betType = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.fillLine()
      }]
    }
  }, _vm._l((_vm.betTypes), function(bt) {
    return _c('option', {
      key: bt.key,
      domProps: {
        "value": bt
      }
    }, [_vm._v("\n                  " + _vm._s(bt.value) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Side:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    on: {
      "change": [function($event) {
        _vm.selection = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.fillLine()
      }]
    }
  }, _vm._l((_vm.sideOptions), function(bt) {
    return _c('option', {
      key: bt.key,
      domProps: {
        "value": bt
      }
    }, [_vm._v("\n                  " + _vm._s(bt.value) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Content:\n            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "name": "content",
      "cols": "50",
      "rows": "20",
      "maxlength": "5000"
    },
    domProps: {
      "value": _vm._s(_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Pick:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pick),
      expression: "pick"
    }],
    attrs: {
      "type": "text",
      "name": "pick",
      "size": "33",
      "disabled": "true",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.pick)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pick = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Spread/OU:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.side),
      expression: "side"
    }],
    attrs: {
      "type": "text",
      "name": "side",
      "size": "5",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.side)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.side = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Line:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    attrs: {
      "type": "text",
      "name": "price",
      "size": "5",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Units:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.units),
      expression: "units"
    }],
    attrs: {
      "type": "text",
      "name": "units",
      "size": "3",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.units)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.units = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit Pick"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-detail-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading product...\n    ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : (_vm.product) ? _c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "product-images"
  }, [_c('div', {
    staticClass: "main-image"
  }, [(_vm.selectedImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedImage.image_url,
      "alt": _vm.product.name
    }
  }) : _c('div', {
    staticClass: "no-image"
  }, [_vm._v("\n            No Image\n          ")])]), _vm._v(" "), (_vm.product.images && _vm.product.images.length > 1) ? _c('div', {
    staticClass: "image-thumbnails"
  }, _vm._l((_vm.product.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "thumbnail",
      class: {
        active: _vm.selectedImage && _vm.selectedImage.id === image.id
      },
      on: {
        "click": function($event) {
          _vm.selectedImage = image
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.image_url,
        "alt": _vm.product.name
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-info-section"
  }, [_c('h1', {
    staticClass: "product-title"
  }, [_vm._v("\n          " + _vm._s(_vm.product.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "product-price-section"
  }, [(_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-badge-large"
  }, [_vm._v("\n            SALE - SAVE " + _vm._s(_vm.product.discount_percentage) + "%\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-display"
  }, [(_vm.product.is_on_sale) ? _c('span', {
    staticClass: "price-regular"
  }, [_vm._v("\n              $" + _vm._s(_vm.formatPrice(_vm.regularPrice)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price-current",
    class: {
      'price-sale': _vm.product.is_on_sale
    }
  }, [_vm._v("\n              $" + _vm._s(_vm.formatPrice(_vm.currentPrice)) + "\n            ")])]), _vm._v(" "), (_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-message"
  }, [_vm._v("\n            🎉 Limited time offer! Save $" + _vm._s(_vm.formatPrice(_vm.regularPrice - _vm.currentPrice)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.description))])]), _vm._v(" "), (_vm.product.variants && _vm.product.variants.length > 0) ? _c('div', {
    staticClass: "variant-selection"
  }, [(_vm.availableColors.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Color:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableColors), function(color) {
    return _c('button', {
      key: color,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor = color
        }
      }
    }, [_vm._v("\n                " + _vm._s(color) + "\n              ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.availableSizes.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Size:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableSizes), function(size) {
    return _c('button', {
      key: size,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedSize === size
      },
      on: {
        "click": function($event) {
          _vm.selectedSize = size
        }
      }
    }, [_vm._v("\n                " + _vm._s(size) + "\n              ")])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quantity-section"
  }, [_c('label', [_vm._v("Quantity:")]), _vm._v(" "), _c('div', {
    staticClass: "quantity-control"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.quantity <= 1
    },
    on: {
      "click": _vm.decrementQuantity
    }
  }, [_vm._v("\n              -\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quantity),
      expression: "quantity",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm._s(_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.incrementQuantity
    }
  }, [_vm._v("\n              +\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn-add-to-cart",
    attrs: {
      "disabled": !_vm.selectedVariant || !_vm.isAuthenticated
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isAuthenticated ? 'Add to Cart' : 'Login to Purchase') + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n            Back to Shop\n          ")])]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n          Please login to add items to your cart.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.addedToCart) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n          Added to cart!\n          "), _c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("\n            View Cart\n          ")])], 1) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/testimonials'
      }
    }
  }, [_vm._v("\n        Add New Testimonial\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.testimonials), function(test, index) {
    return _c('div', {
      key: test.id,
      staticClass: "colum one_half"
    }, [_c('blockquote', [_c('p', [_c('span', {
      staticClass: "dropcap"
    }, [_vm._v(_vm._s(index))]), _vm._v("\n            " + _vm._s(test.content) + "\n          ")]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + ",  "), _c('b', [_vm._v(_vm._s(test.type))])])]), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn red",
      attrs: {
        "to": {
          path: '/admin/testimonial/' + test.id
        }
      }
    }, [_vm._v("\n          Edit\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(test)
        }
      }
    }, [_vm._v("Delete")])], 1)
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n      Shopping Cart\n    ")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-cart"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("\n        🛒\n      ")]), _vm._v(" "), _c('h2', [_vm._v("Your cart is empty")]), _vm._v(" "), _c('p', [_vm._v("Add some items from our shop to get started!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n        Continue Shopping\n      ")])]) : _c('div', {
    staticClass: "cart-content"
  }, [_c('div', {
    staticClass: "cart-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("\n              No Image\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('h3', {
      staticClass: "item-name"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [(item.isOnSale) ? _c('span', {
      staticClass: "sale-indicator"
    }, [_vm._v("SALE")]) : _vm._e(), _vm._v("\n              $" + _vm._s(_vm.formatPrice(item.price)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-actions"
    }, [_c('div', {
      staticClass: "quantity-control"
    }, [_c('button', {
      attrs: {
        "disabled": item.quantity <= 1
      },
      on: {
        "click": function($event) {
          _vm.decrementQuantity(item)
        }
      }
    }, [_vm._v("\n                -\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.quantity),
        expression: "item.quantity",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": _vm._s(item.quantity)
      },
      on: {
        "change": function($event) {
          _vm.updateQuantity(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.quantity = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.incrementQuantity(item)
        }
      }
    }, [_vm._v("\n                +\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-total"
    }, [_vm._v("\n              $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-remove",
      attrs: {
        "title": "Remove item"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(item)
        }
      }
    }, [_vm._v("\n              ×\n            ")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cart-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal (" + _vm._s(_vm.cartItemCount) + " items)")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), (_vm.isAuthenticated) ? _c('button', {
    staticClass: "btn-checkout",
    on: {
      "click": function($event) {
        _vm.$router.push('/checkout')
      }
    }
  }, [_vm._v("\n            Proceed to Checkout\n          ")]) : _c('button', {
    staticClass: "btn-login",
    on: {
      "click": function($event) {
        _vm.$router.push('/register')
      }
    }
  }, [_vm._v("\n            Login to Checkout\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n            Continue Shopping\n          ")]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n            Please login to complete your purchase.\n          ")]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h1', [_vm._v("FAQ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("I just paid for premium picks, how do I view picks?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("Do you email picks?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', [_vm._v("Can I view picks on my smartphone?")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', [_vm._v("I just registered for the website, how do I view free picks?")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h5', [_vm._v("I'm a premium member, how come the free picks do not show when I click \"View Picks?\"")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h5', [_vm._v("What are units?")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h5', [_vm._v("Most of your picks are for 1 unit, do you ever deviate from betting this unit?")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Stumpthespread strives to make this website intuitive and easy to use, however we know there will be many questions about the functionality of this site. This document should solve most of your questions. If it does not, please send us an email through our "), _c('a', {
    attrs: {
      "href": "contact.php"
    }
  }, [_vm._v("contact")]), _vm._v(" page.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Log into the website using the \"Login\" button found at the top right of the website. Once logged in, click \"View Picks\" which appears next to your email address also found in the top right of the website.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Yes, when you are a premium member, you can set up pick notifications for email or text message.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("You can view the website in your smartphone's browser. We are currently working on a web app for smartphones to make it easier to view picks.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Once logged in, click \"Free Picks\" in the navigation bar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Free picks are of a lower confidence level therefore we do not include them in the \"View Picks\" view or in our Results page when they are not represented as a premium pick. If you would like to look at the free picks, you will have to click \"Free Picks\" found in the navigation bar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Units are a measurement of the size of a bet. This size is relative to your bankroll. A unit should be between 0.5 - 1% of your bankroll. For example, if you have $10,000 and we have a pick for 1 unit, that would be $50 - $100. Keeping your unit size small limits your risk of ruin.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Our system calls for mainly 1 unit picks. When we deviate and bet more on a game it will be because it fits one of our high unit systems.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you have any further questions, please consult us via email at our "), _c('a', {
    attrs: {
      "href": "contact.php"
    }
  }, [_vm._v("contact")]), _vm._v(" page.")])
}]}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Terms of Use and Copyright Notice")]), _vm._v(" "), _c('p', [_vm._v("By taking advantage of this site or the information in the StumptheSpread.com website, newsletters or emails, you are agreeing to these terms and conditions. You must be at least 18 years of age to use our services. The information on this site is for your enjoyment and entertainment purposes only. We are not liable for any losses that incurred as a result of the information purchased through this website. This is not a betting site. Information and recommendations made are for entertainment and informational purposes only. This information is not intended to violate any local, state, or federal laws. Past performance and results do not guarantee future results. Any reliance on such information and recommendations is at the sole discretion and risk of the subscriber.")]), _vm._v(" "), _c('p', [_vm._v("Once leaving our site, you are responsible for your actions on other sites that may link from this site. We do not control the content or services of other websites. We also do not encourage any participation in services offered by other websites. Please review the laws in your state and country. You are responsible for your actions and use of information from this site and for your actions once you leave this site.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Refund Policy")]), _vm._v(" "), _c('p', [_vm._v("All sales made to StumptheSpread.com are final. No reimbursements or refunds will be given for any reason.")]), _vm._v(" "), _c('h5', [_vm._v("Copyright Notice")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2009-" + _vm._s(_vm.year) + " StumptheSpread.com. All rights reserved.")]), _vm._v(" "), _c('p', [_vm._v("Unless otherwise indicated, this site and its contents (including, but not limited to, all text, photographs, images, video, and audio) are the exclusive property of StumptheSpread.com and are protected by copyright, trademark, and other laws.")]), _vm._v(" "), _c('p', [_vm._v("Except as may be permitted under the Copyright Act of 1976, you may not reproduce, publish, transmit, distribute, perform, display, modify, create derivative works from, sell, or otherwise exploit this site or any of its contents without our prior written permission.")]), _vm._v(" "), _c('p', [_vm._v("You may not, under any circumstances, reproduce materials in print or verbal form or reproduce them on the Internet without express written permission from StumptheSpread.com. Doing so will result in being banned from this site and losing any subscription privileges without refund.")]), _vm._v(" "), _c('p', [_vm._v("Any questions or comments may be sent to: policy@stumpthespread.com")])]), _vm._v(" "), _c('sidebar')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you or anyone you know has a gambling problem, please seek help and start by visiting "), _c('a', {
    attrs: {
      "href": "https://www.gamblersanonymous.org/ga/"
    }
  }, [_vm._v("Gamblers Anonymous.")])])
}]}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: ['big-btn', _vm.mutableColor],
    style: (_vm.computedStyle),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  Purchase \n")])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('p', [_vm._v("\n        Search Users By Email:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        _vm.searchUsers()
      }
    }
  }, [_vm._v("\n          Search Users\n        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.users.length) ? _c('table', [_c('h4', [_vm._v("Users:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.premium === "1" ? "Yes" : "No"))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn orange",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_vm._v("\n              Edit\n            ")])])])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Premium")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])
}]}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-orders-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v("\n      Loading your orders...\n    ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("\n        ⚠️\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")])]) : (_vm.orders.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("\n        📦\n      ")]), _vm._v(" "), _c('h2', [_vm._v("\n        No orders yet\n      ")]), _vm._v(" "), _c('p', [_vm._v("You haven't placed any orders yet. Start shopping!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n        Browse Products\n      ")])]) : _c('div', {
    staticClass: "orders-list"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id,
      staticClass: "order-card",
      on: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_c('div', {
      staticClass: "order-header"
    }, [_c('div', {
      staticClass: "order-info"
    }, [_c('h3', [_vm._v("\n              Order #" + _vm._s(order.order_number) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "order-date"
    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(order.created_at)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "order-status"
    }, [_c('span', {
      class: ['status-badge', order.status]
    }, [_vm._v("\n              " + _vm._s(_vm.formatStatus(order.status)) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "order-items-preview"
    }, [_vm._l((order.items.slice(0, 3)), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "item-preview"
      }, [_c('div', {
        staticClass: "item-image-small"
      }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
        attrs: {
          "src": _vm.getPrimaryImage(item.product).image_url,
          "alt": item.product_name
        }
      }) : _c('div', {
        staticClass: "no-image-small"
      }, [_vm._v("\n                ?\n              ")])])])
    }), _vm._v(" "), (order.items.length > 3) ? _c('span', {
      staticClass: "more-items"
    }, [_vm._v("\n            +" + _vm._s(order.items.length - 3) + " more\n          ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "order-footer"
    }, [_c('div', {
      staticClass: "order-total"
    }, [_c('span', {
      staticClass: "total-label"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "total-amount"
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(order.total_cents)))])]), _vm._v(" "), _c('button', {
      staticClass: "btn-view",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.viewOrder(order.id)
        }
      }
    }, [_vm._v("\n            View Details →\n          ")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("My Orders")]), _vm._v(" "), _c('p', [_vm._v("View and track your order history")])])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden"
  }, [_c('div', {
    ref: "loginBox",
    attrs: {
      "id": "login-box"
    }
  }, [_c('form', [_c('label', {
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Email: ")]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticStyle: {
      "color": "red",
      "padding-left": "30px"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "login-username",
      "type": "text",
      "name": "login_username"
    },
    domProps: {
      "value": _vm._s(_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "login-password",
      "type": "password",
      "name": "login_password"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('span', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "id": "login-submit",
      "type": "submit",
      "name": "submit",
      "value": "Login"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "lostpass",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  }, [_vm._v("Forgot password?")])])])])
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('form', [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Content:\n            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.content),
      expression: "testimonial.content"
    }],
    attrs: {
      "name": "content",
      "cols": "50",
      "rows": "20",
      "maxlength": "5000"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.content = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Author:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.author),
      expression: "testimonial.author"
    }],
    attrs: {
      "type": "text",
      "name": "author",
      "size": "33",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.author)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.author = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Type: (free member, customer, etc)\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.type),
      expression: "testimonial.type"
    }],
    attrs: {
      "type": "text",
      "name": "type",
      "size": "20",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.type = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.records), function(record) {
    return _c('div', {
      key: record.id,
      staticClass: "post full-width"
    }, [_c('b', [_vm._v(_vm._s(record.date))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.pick))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.side))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.price))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.risk))]), _vm._v("\n         \n        "), _c('b', [_vm._v("units")]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.towin))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.result))]), _vm._v("\n           \n        "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "sml-btn blue",
      attrs: {
        "to": {
          path: '/admin/record/' + record.record_id
        }
      }
    }, [_vm._v("\n          Edit\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn orange",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(record)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn green",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'W')
        }
      }
    }, [_vm._v("Win")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'L')
        }
      }
    }, [_vm._v("Loss")])], 1)
  }), _vm._v(" "), _c('p', [(!_vm.hideMore) ? _c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n          More ->\n        ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), (_vm.results) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.results), function(result) {
    return _c('p', {
      key: result.id
    }, [_vm._v("\n              " + _vm._s(result.name) + ":\n              "), _c('b', [_vm._v(_vm._s(result.win) + "-" + _vm._s(result.loss) + " " + _vm._s(result.units) + " units\n                " + _vm._s(Number(result.win_percent).toFixed(2) * 100) + "%W")])])
  })) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Record")])])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-confirmation-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading order details...\n    ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("\n        ⚠️\n      ")]), _vm._v(" "), _c('h2', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-home",
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n        Go to Home\n      ")])]) : (_vm.order) ? _c('div', {
    staticClass: "confirmation-content"
  }, [_c('div', {
    staticClass: "success-header"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_vm._v("\n          ✓\n        ")]), _vm._v(" "), _c('h1', [_vm._v("\n          Order Confirmed!\n        ")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your purchase. Your order has been received and is being processed.")])]), _vm._v(" "), _c('div', {
    staticClass: "order-details-card"
  }, [_c('div', {
    staticClass: "order-header"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('h2', [_vm._v("\n              Order #" + _vm._s(_vm.order.order_number) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "order-date"
  }, [_vm._v("\n              " + _vm._s(_vm.formatDate(_vm.order.created_at)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "order-status"
  }, [_c('span', {
    class: ['status-badge', _vm.order.status]
  }, [_vm._v("\n              " + _vm._s(_vm.formatStatus(_vm.order.status)) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-items-section"
  }, [_c('h3', [_vm._v("Order Items")]), _vm._v(" "), _c('div', {
    staticClass: "order-items"
  }, _vm._l((_vm.order.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
      attrs: {
        "src": _vm.getPrimaryImage(item.product).image_url,
        "alt": item.product_name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("\n                  No Image\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v("\n                  " + _vm._s(item.product_name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-quantity"
    }, [_vm._v("\n                Qty: " + _vm._s(item.quantity) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(item.unit_price_cents)) + "\n              ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "shipping-info"
  }, [_c('h3', [_vm._v("Shipping Address")]), _vm._v(" "), _c('p', {
    staticClass: "shipping-address"
  }, [_vm._v("\n            " + _vm._s(_vm.order.shipping_name)), _c('br'), _vm._v("\n            " + _vm._s(_vm.order.shipping_address1)), _c('br'), _vm._v(" "), (_vm.order.shipping_address2) ? _c('span', [_vm._v(_vm._s(_vm.order.shipping_address2)), _c('br')]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.order.shipping_city) + ", " + _vm._s(_vm.order.shipping_state) + " " + _vm._s(_vm.order.shipping_postal_code)), _c('br'), _vm._v("\n            " + _vm._s(_vm.order.shipping_country) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "shipping-email"
  }, [_vm._v("\n            Email: " + _vm._s(_vm.order.shipping_email) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.total_cents)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.total_cents)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn-orders",
    on: {
      "click": function($event) {
        _vm.$router.push('/my-orders')
      }
    }
  }, [_vm._v("\n          View All Orders\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Continue Shopping\n        ")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/admin/pick'
      }
    }
  }, [_vm._v("\n        Add Picks\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/picks'
      }
    }
  }, [_vm._v("\n        Manage Picks\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn orange",
    attrs: {
      "to": {
        path: '/admin/record'
      }
    }
  }, [_vm._v("\n        Manage Record\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/testimonial'
      }
    }
  }, [_vm._v("\n        Add Testimonials\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/testimonials'
      }
    }
  }, [_vm._v("\n        Manage Testimonials\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/admin/posts/0'
      }
    }
  }, [_vm._v("\n        Add Blog Post\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn green",
    attrs: {
      "to": {
        path: '/admin/posts'
      }
    }
  }, [_vm._v("\n        Manage Blog Posts\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/users'
      }
    }
  }, [_vm._v("\n        Manage Users\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/package'
      }
    }
  }, [_vm._v("\n        Manage Packages\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn orange",
    attrs: {
      "to": {
        path: '/admin/categories'
      }
    }
  }, [_vm._v("\n        Manage Categories\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "big-btn black",
    on: {
      "click": function($event) {
        _vm.clearCache()
      }
    }
  }, [_vm._v("\n        Clear Cache\n      ")])], 1), _vm._v(" "), (_vm.admin) ? _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              Overall: "), _c('b', [_vm._v(_vm._s(_vm.admin["overall"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              Free: "), _c('b', [_vm._v(_vm._s(_vm.admin["free"]) + " members"), _c('b')])]), _vm._v(" "), _c('p', [_vm._v("\n              All Sports: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["all"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NFL: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nfl"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAF: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["ncaaf"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NBA: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nba"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAB: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["ncaab"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              MLB: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["mlb"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NHL: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nhl"]) + " members")])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Members")])])
}]}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n      Checkout\n    ")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("Your cart is empty. Please add items before checking out.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n        Back to Shop\n      ")])]) : _c('div', {
    staticClass: "checkout-content"
  }, [_c('div', {
    staticClass: "checkout-form"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h2', [_vm._v("Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("First Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.first_name),
      expression: "shipping.first_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Last Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.last_name),
      expression: "shipping.last_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.email),
      expression: "shipping.email"
    }],
    attrs: {
      "type": "email",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.phone),
      expression: "shipping.phone"
    }],
    attrs: {
      "type": "tel",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 1 *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line1),
      expression: "shipping.address_line1"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.address_line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line2),
      expression: "shipping.address_line2"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.address_line2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.city),
      expression: "shipping.city"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State/Province *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.state),
      expression: "shipping.state"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.state = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Postal Code *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.postal_code),
      expression: "shipping.postal_code"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.postal_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Country *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.country),
      expression: "shipping.country"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": _vm._s(_vm.shipping.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.country = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('div', {
    staticClass: "processing-message"
  }, [_vm._v("\n          " + _vm._s(_vm.processingMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.processing && !_vm.orderCreated) ? _c('div', [_c('div', {
    ref: "paypalButtons",
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])]), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.cardSubmitDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitCardPayment()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.cardSubmitDisabled ? 'Processing...' : ("Pay $" + (_vm.formatPrice(_vm.cartTotal)))) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "summary-item"
    }, [_c('div', {
      staticClass: "summary-item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-details"
    }, [_c('div', {
      staticClass: "summary-item-name"
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-qty"
    }, [_vm._v("\n                  Qty: " + _vm._s(item.quantity) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-price"
    }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n              ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-back-to-cart",
    on: {
      "click": function($event) {
        _vm.$router.push('/cart')
      }
    }
  }, [_vm._v("\n          ← Back to Cart\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit User")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "editUser"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Email:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "size": "33",
      "maxlength": "200"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Premium:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.premium),
      expression: "user.premium"
    }],
    attrs: {
      "type": "radio",
      "name": "premiumYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.premium, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.premium = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "premiumYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.premium),
      expression: "user.premium"
    }],
    attrs: {
      "type": "radio",
      "name": "premiumNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.premium, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.premium = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "premiumNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Active:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.active),
      expression: "user.active"
    }],
    attrs: {
      "type": "radio",
      "name": "activeYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.active, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.active = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "activeYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.active),
      expression: "user.active"
    }],
    attrs: {
      "type": "radio",
      "name": "activeNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.active, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.active = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "activeNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NFL:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nfl),
      expression: "user.nfl"
    }],
    attrs: {
      "type": "radio",
      "name": "nflYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.nfl, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.nfl = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nflYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nfl),
      expression: "user.nfl"
    }],
    attrs: {
      "type": "radio",
      "name": "nflNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.nfl, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.nfl = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nflNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NCAAF:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ncaaf),
      expression: "user.ncaaf"
    }],
    attrs: {
      "type": "radio",
      "name": "ncaafYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.ncaaf, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.ncaaf = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ncaafYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ncaaf),
      expression: "user.ncaaf"
    }],
    attrs: {
      "type": "radio",
      "name": "ncaafNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.ncaaf, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.ncaaf = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ncaafNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NBA:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nba),
      expression: "user.nba"
    }],
    attrs: {
      "type": "radio",
      "name": "nbaYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.nba, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.nba = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nbaYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nba),
      expression: "user.nba"
    }],
    attrs: {
      "type": "radio",
      "name": "nbaNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.nba, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.nba = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nbaNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NCAAB:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ncaab),
      expression: "user.ncaab"
    }],
    attrs: {
      "type": "radio",
      "name": "ncaabYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.ncaab, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.ncaab = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ncaabYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ncaab),
      expression: "user.ncaab"
    }],
    attrs: {
      "type": "radio",
      "name": "ncaabNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.ncaab, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.ncaab = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ncaabNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MLB:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mlb),
      expression: "user.mlb"
    }],
    attrs: {
      "type": "radio",
      "name": "mlbYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.mlb, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.mlb = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mlbYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mlb),
      expression: "user.mlb"
    }],
    attrs: {
      "type": "radio",
      "name": "mlbNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.mlb, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.mlb = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mlbNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NHL:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nhl),
      expression: "user.nhl"
    }],
    attrs: {
      "type": "radio",
      "name": "nhlYes"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.user.nhl, 1)
    },
    on: {
      "click": function($event) {
        _vm.user.nhl = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nhlYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nhl),
      expression: "user.nhl"
    }],
    attrs: {
      "type": "radio",
      "name": "nhlNo"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.user.nhl, 0)
    },
    on: {
      "click": function($event) {
        _vm.user.nhl = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "nhlNo"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Change Password")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "name": "password",
      "autocomplete": "off",
      "maxlength": "100",
      "placeholder": ("min " + _vm.MIN_PASSWORD_LENGTH + " characters")
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Leave blank to keep the current password.")])])]), _vm._v(" "), (!_vm.membership) ? _c('tr', [_c('td', [_c('button', {
    staticClass: "big-btn orange",
    on: {
      "click": function($event) {
        _vm.addMembership()
      }
    }
  }, [_vm._v("\n                Add Membership\n              ")])])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("All Sports Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.allsports_expire),
      expression: "membership.allsports_expire"
    }],
    attrs: {
      "type": "date",
      "name": "allSportsExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.allsports_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.allsports_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("NFL Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.nfl_expire),
      expression: "membership.nfl_expire"
    }],
    attrs: {
      "type": "date",
      "name": "nflExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.nfl_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.nfl_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("NCAAF Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.ncaaf_expire),
      expression: "membership.ncaaf_expire"
    }],
    attrs: {
      "type": "date",
      "name": "ncaafExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.ncaaf_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.ncaaf_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("NBA Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.nba_expire),
      expression: "membership.nba_expire"
    }],
    attrs: {
      "type": "date",
      "name": "nbaExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.nba_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.nba_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("NCAAB Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.ncaab_expire),
      expression: "membership.ncaab_expire"
    }],
    attrs: {
      "type": "date",
      "name": "ncaabExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.ncaab_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.ncaab_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("MLB Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.mlb_expire),
      expression: "membership.mlb_expire"
    }],
    attrs: {
      "type": "date",
      "name": "mlbExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.mlb_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.mlb_expire = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.membership) ? _c('tr', [_c('td', [_vm._v("NHL Expire")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.membership.nhl_expire),
      expression: "membership.nhl_expire"
    }],
    attrs: {
      "type": "date",
      "name": "nhlExpire"
    },
    domProps: {
      "value": _vm._s(_vm.membership.nhl_expire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.membership.nhl_expire = $event.target.value
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Save"
    }
  })])
}]}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('h3', [_vm._v("Happy Customers")]), _vm._v(" "), _c('p', [_vm._v("\n        Since the inception of StumptheSpread.com we have valued the opinions\n        of our customers. We pride ourselves on going above and beyond when it\n        comes to customer service and guarantee we're the best in the industry\n        in that department. Below are handicapper reviews, customer comments\n        and customer reviews.\n      ")]), _vm._v(" "), _c('p', [_vm._v("Send us your comment to support@stumpthespread.com")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "6204371474",
      "ad-style": "display:inline-block;width:728px;height:90px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.testimonials), function(test, index) {
    return _c('div', {
      key: test.id,
      staticClass: "colum one_half"
    }, [_c('blockquote', [_c('p', [_c('span', {
      staticClass: "dropcap"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n          " + _vm._s(test.content) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "sprite testimony-bg"
    }), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + "  "), _c('b', [_vm._v(_vm._s(test.type))])])])], 1)
  }), _vm._v("\n    ';\n  ")], 2)])
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site-wrapper"
    }
  }, [_c('sts-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('sts-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pick.title))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('span', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.pick.sport.sport))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.pick.date))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.pick.content)
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.pick.pick))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.side))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.price))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.units))]), _vm._v("\n   \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.units > 1 ? 'units' : 'unit'))])])
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Get in touch with us")]), _vm._v(" "), _c('p', [_vm._v("We love to hear from our members. Please drop us a line if you need any help or have any comments for us. We appreciate all the input!")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('name')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n          Please enter your name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n          Please enter a valid email\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('message')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter your message\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "id": "contact_us"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.from),
      expression: "contact.from"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.from = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Message\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form",
    attrs: {
      "id": "textarea"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "message_input",
      "name": "message",
      "rows": "3",
      "cols": "4",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LcSWxkUAAAAABKb28GRtkDtDTTv6bOSJeWr4k5p"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success-box",
    attrs: {
      "id": "success"
    }
  }, [_vm._v("\n        Your message was sent succesfully! "), _c('span', {
    staticClass: "close"
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('testimonial', {
    attrs: {
      "test": _vm.testimonial
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "submit"
    }
  }, [_c('input', {
    staticClass: "big-btn special",
    attrs: {
      "type": "submit",
      "value": "Send Message",
      "name": "submitButton"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Contact Info")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sprite stsblue1"
  }), _vm._v(" "), _c('p', [_c('strong', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Email:")]), _vm._v(" support@stumpthespread.com"), _c('br')])])])
}]}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Category")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cat.category),
      expression: "cat.category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.cat.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cat.category = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Save"
    }
  })])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.sportOptions.length > 2) ? _c('div', {
    staticClass: "sport-filter"
  }, _vm._l((_vm.sportOptions), function(opt) {
    return _c('button', {
      key: opt,
      staticClass: "sport-pill",
      class: {
        active: _vm.selectedSport === opt
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectSport(opt)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.sportLabel(opt)) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredPicks), function(p) {
    return (_vm.picks) ? _c('pick', {
      key: p.id,
      attrs: {
        "pick": p
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('p', [_vm._v("\n        There are no premium picks currently posted. To receive picks\n        immediately when they are posted, please set up pick notifications in\n        the\n        "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n          my account section.\n        ")])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [(post) ? _c('span', {
      staticClass: "category"
    }, [_vm._v(_vm._s(post.category.category))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn blue",
      attrs: {
        "to": {
          path: '/admin/posts/' + post.id
        }
      }
    }, [_vm._v("\n          Edit Post\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      attrs: {
        "href": ";javascript"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(post)
        }
      }
    }, [_vm._v("Delete Post")])], 1)
  }), _vm._v(" "), (!_vm.hideMore) ? _c('p', [_c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n          More ->\n        ")])]) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Privacy Policy: We Respect Your Privacy!")]), _vm._v(" "), _c('p', [_vm._v("We respect your privacy. Your information will not be shared with any third party and you may unsubscribe at anytime.")]), _vm._v(" "), _c('h4', [_vm._v("Privacy Overview")]), _vm._v(" "), _c('p', [_vm._v("All information submitted to StumptheSpread.com is confidential and is used only for market research purposes.  This information will not be shared, traded, or sold to any third party companies.  Information we maintain is used to improve the quality of our site.  It will only be used to communicate with visitors who want to receive additional information. An anonymous visitor to our site will maintain their anonymity under all circumstances. StumptheSpread.com does not attempt to identify visitors if they do not voluntarily register on the site. If you no longer want to receive e-mail communications from our site, please use the unsubscribe link provided on every e-mail we send out.")]), _vm._v(" "), _c('h4', [_vm._v("Personal Information")]), _vm._v(" "), _c('p', [_vm._v("All personal data you provide to StumptheSpread.com is confidential.  This may include your name, address, phone number, and any other details.  This data is never sold, traded, or used for any purpose other than to improve the website.")]), _vm._v(" "), _c('h4', [_vm._v("Payment Information")]), _vm._v(" "), _c('p', [_vm._v("Payments are submitted through a third party processor.  We do not keep your credit/debit card number or any other payment-related information.  StumptheSpread.com uses only the most respected payment processors, but we cannot be held responsible for the privacy of their sites.  We encourage you to examine their privacy policy if you have any questions about the information they retain. ")]), _vm._v(" "), _c('p', [_vm._v("Any further questions can be directed to support@stumpthespread.com")])])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Manage Categories")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn orange",
    attrs: {
      "to": {
        path: '/admin/categories/0'
      }
    }
  }, [_vm._v("\n        Add New Category\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.categories), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "post full-width"
    }, [_c('b', [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "sml-btn blue",
      attrs: {
        "to": {
          path: '/admin/categories/' + item.id
        }
      }
    }, [_vm._v("\n          Edit\n        ")])], 1)
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "id": "home-page"
    }
  }, [_c('router-view'), _vm._v(" "), _c('vue-toastr', {
    ref: "toastr"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Disclaimer")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com is not responsible for any decisions made, financial or otherwise, based on information or links provided by Stumpthespread.com. The information we provide is for informational and educational purposes only. Stumpthespread.com does not guarantee any of the suggestions made. Past results do not guarantee future success.")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com and its tipsters, contributors, sponsors, advertisers, email correspondence and any information appearing on this site are not meant in any way to be a source of professional advice or recommendations to in any way gamble, place bets and/or wager and no reliance is to be placed on the same. We do not undertake any responsibility and/or liability for any losses and/or damages sustained by any person or persons using services on our site and we shall not be responsible and/or liable for any losses or damages due to any information or otherwise contained on this web site or through links, sponsors and email correspondence, whether due to inaccuracy, error, omission or bad judgment or any reason whatsoever.")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com is not responsible in any way regarding picks and predictions posted through email. We advise all viewers to use discretion when viewing our picks. Please bet within your means. If you encounter gambling problems of any kind, please contact the gambling help authorities in your area. Please visit, Gamblers Anonymous.")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com notes that odds and betting lines tend to fluctuate often without notice. We will not be liable for any incorrect odds and lines.")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com does not provide gaming or gambling capabilities on its site. It is a sports information site, although odds and betting lines are part of that information. It is very important to check the laws and regulation in your own country regarding gambling and sports betting, as it might differ from country to country.")]), _vm._v(" "), _c('p', [_vm._v("Stumpthespread.com is not responsible for any fees or inconveniences which result from either our email or text messaging systems. We encourage all viewers to only choose the text messaging option if their phone plan supports it. StumptheSpread will not reimburse any one for accrued text messaging or phone bills. Nor will we be held responsible for any issues from our text messaging or email system.")]), _vm._v(" "), _c('p', [_vm._v("All sales made at StumptheSpread are final. No reimbursements or refunds will be given for any reason. ")]), _vm._v(" "), _c('p', [_vm._v("Any further questions may be directed to policy@stumpthespread.com")])])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "sprite stumpthespread"
  })])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-holder"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.currentUser),
      expression: "!currentUser"
    }]
  }, [_c('a', {
    staticClass: "sml-btn green",
    attrs: {
      "id": "login-link",
      "href": "#login-box"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "sml-btn red",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n          Register For Free\n        ")])], 1), _vm._v(" "), (_vm.currentUser) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.currentUser.email) + "   \n        "), _c('router-link', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "to": {
        path: '/viewpicks'
      }
    }
  }, [_vm._v("\n          View Picks\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "grey"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")]), _vm._v("\n             \n          "), (!_vm.currentUser.admin) ? _c('router-link', {
    staticStyle: {
      "color": "grey"
    },
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n            My Account\n          ")]) : _vm._e(), _vm._v(" "), (_vm.currentUser.admin) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_c('font', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("\n              Admin\n            ")])], 1) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "4px"
    }
  }, [_c('ul', {
    staticClass: "sf-menu"
  }, [_c('li', {
    class: {
      current_page_item: this.$route.name === 'home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n            Home\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.path.indexOf('packages') > 0,
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n            Premium Picks\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n                All Sports Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nfl'
      }
    }
  }, [_vm._v("\n                NFL Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/ncaaf'
      }
    }
  }, [_vm._v("\n                NCAAF Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nba'
      }
    }
  }, [_vm._v("\n                NBA Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/ncaab'
      }
    }
  }, [_vm._v("\n                NCAAB Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/mlb'
      }
    }
  }, [_vm._v("\n                MLB Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_vm._v("\n                NHL Packages\n              ")])], 1)])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'freepicks'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n            Free Picks\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'blog'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("\n            Blog\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n            Contact\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'testimonials'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("\n            Testimonials\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'faq'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n            FAQ\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'odds'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/odds'
      }
    }
  }, [_vm._v("\n            Odds\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("\n            Tools\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("\n                Bet Sizing Calculator\n              ")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "shop-menu-item",
    class: {
      current_page_item: this.$route.path.indexOf('shop') > -1 || this.$route.path.indexOf('cart') > -1
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.currentUser && _vm.cartItemCount > 0 ? '/cart' : {
        name: 'shop'
      }
    }
  }, [_vm._v("\n            Shop\n            "), (_vm.currentUser && _vm.cartItemCount > 0) ? _c('span', {
    staticClass: "cart-badge"
  }, [_vm._v(_vm._s(_vm.cartItemCount))]) : _vm._e()])], 1)])]), _vm._v(" "), (!_vm.isHome && _vm.bc) ? _c('div', {
    attrs: {
      "id": "pagename"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bc.meta.breadcrumb))]), _vm._v(" "), _c('p', {
    staticClass: "breadcrumbs"
  }, [_vm._v("\n          You are here :\n          "), _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("\n            Home\n          ")]), _vm._v("\n          / " + _vm._s(_vm.params.sport ? _vm.params.sport.toUpperCase() : _vm.bc.meta.subtitle) + "\n        ")], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isHome) ? _c('div', {
    attrs: {
      "id": "slider-holder"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "slider"
    }
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsbutton slide-img",
    attrs: {
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Free Pick")]), _vm._v(" "), (_vm.pick) ? _c('p', [_vm._v("\n              " + _vm._s(_vm.pick.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pick) ? _c('p', {
    staticClass: "truncate",
    attrs: {
      "id": "freePickContent"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.pick.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn grey",
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n              More Free Picks\n            ")]), _vm._v(">\n            "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n              Become a Free Member\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n              Buy Premium Picks\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsblue slide-img",
    attrs: {
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("NHL Full Season Package")]), _vm._v(" "), _c('p', [_vm._v("\n              STS is ready to dominate the ice this season. Our team has\n              poured hundreds of hours over the offseason to make sure we are\n              delivering the best hockey picks possible. No team is more\n              prepared for the 2019-2020 hockey season! Get $100 off our Full\n              NHL Season Package which includes premium picks every single day\n              and playoff picks. This is a 33% saving! Join today, offer ends\n              a week before the regular season!"), _c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("\n                  Purchase a full NHL season for $299.99!\n                ")])], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_vm._v("\n              Purchase NHL Full Season Package\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsredcheck slide-img"
  }), _vm._v(" "), _c('h2', [_vm._v("NCAAB Full Season Package")]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAB continues to be one of our big money makers at\n              Stumpthespread. We’ve consistently put up strong profits year in\n              and year out in college basketball racking up nearly +500 units\n              all time. Last season we sprinted to the finish over the last\n              two months putting up +150 units through February and March, and\n              we’re looking to carry over that momentum into this campaign.\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/ncaab'
      }
    }
  }, [_vm._v("\n              Purchase NCAAB Full Season Package\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stspoker slide-img"
  }), _vm._v(" "), _c('h2', [_vm._v("Testimonials")]), _vm._v(" "), _c('p', [_vm._v("You Will Win!")]), _vm._v(" "), (_vm.testimonial) ? _c('p', [_vm._v("\n              " + _vm._s(_vm.testimonial.content) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn grey",
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n              More Free Picks\n            ")]), _vm._v(">\n            "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n              Become a Free Member\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n              Buy Premium Picks\n            ")])], 1)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slider-nav-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "slider-nav"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sprite slider-nav-right",
    staticStyle: {
      "float": "left"
    }
  })])
}]}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Live Odds")]), _vm._v(" "), (_vm.odds.mlb && _vm.odds.mlb.live && _vm.odds.mlb.live.data && _vm.odds.mlb.live.data.games.length) ? _c('table', [_c('thead', [_c('tr', {
    staticClass: "bg-green"
  }, [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                In Progress\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                Score\n              ")]), _vm._v(" "), _vm._l((_vm.odds.mlb.live.data.headers), function(h) {
    return _c('th', {
      key: h,
      staticClass: "text-right"
    }, [(h === 'BetAnySports') ? _c('a', {
      attrs: {
        "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1",
        "target": "_blank"
      }
    }, [_vm._v("BetAnySports")]) : _vm._e(), _vm._v(" "), (h === 'BetOnline') ? _c('a', {
      attrs: {
        "href": "https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/",
        "target": "_blank"
      }
    }, [_vm._v("BetOnline")]) : _vm._e(), _vm._v(" "), (h !== 'BetAnySports' && h !== 'BetOnline') ? _c('span', [_vm._v("\n                  " + _vm._s(h) + "\n                ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "no-border"
  }, [_vm._l((_vm.odds.mlb.live.data.games), function(o) {
    return [_c('tr', {
      key: o.awayCode,
      staticStyle: {
        "z-index": "1"
      }
    }, [_c('td', {
      staticClass: "text-left no-border right-border bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.awayTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center no-border right-border"
    }, [_vm._v("\n                  " + _vm._s(o.awayScore) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right no-border right-border"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_away) + "\n                    " + _vm._s(odd.point_spread_away_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_away) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + "\n                  ")]) : _vm._e()])
    })], 2), _vm._v(" "), _c('tr', {
      key: o.homeCode,
      staticStyle: {
        "border-bottom": "1px"
      }
    }, [_c('td', {
      staticClass: "text-left bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.homeTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(o.homeScore) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_home) + "\n                    " + _vm._s(odd.point_spread_home_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_home) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.under_line) + "\n                  ")]) : _vm._e()])
    })], 2)]
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.upcomingGames.length) ? _c('div', {
    staticClass: "column"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "bg-green"
  }, [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                Upcoming\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                Date\n              ")]), _vm._v(" "), _vm._l((_vm.upcomingHeaders), function(h) {
    return _c('th', {
      key: h,
      staticStyle: {
        "text-align": "right"
      }
    }, [(h === 'BetOnline') ? _c('a', {
      attrs: {
        "href": "https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/",
        "target": "_blank"
      }
    }, [_vm._v("BetOnline")]) : _vm._e(), _vm._v(" "), (h === 'BetAnySports') ? _c('a', {
      attrs: {
        "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1",
        "target": "_blank"
      }
    }, [_vm._v("BetAnySports")]) : _vm._e(), _vm._v(" "), (h !== 'BetAnySports' && h !== 'BetOnline') ? _c('span', [_vm._v("\n                  " + _vm._s(h) + "\n                ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "no-border"
  }, [_vm._l((_vm.upcomingGames), function(o) {
    return [_c('tr', {
      key: o.awayCode
    }, [_c('td', {
      staticClass: "text-left no-border right-border bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.awayTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center no-border right-border"
    }, [_vm._v("\n                  " + _vm._s(o.date) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right no-border right-border"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_away) + "\n                    " + _vm._s(odd.point_spread_away_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_away) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.over_line) + "\n                  ")]) : _vm._e()])
    })], 2), _vm._v(" "), _c('tr', {
      key: o.homeCode,
      staticStyle: {
        "border-bottom": "1px"
      }
    }, [_c('td', {
      staticClass: "text-left bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.homeTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(o.time) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_home) + "\n                    " + _vm._s(odd.point_spread_home_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_home) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.under_line) + "\n                  ")]) : _vm._e()])
    })], 2)]
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-left": "2px"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h6', [_vm._v("Select Sport")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("MLB")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "target": "_top"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "hspace": "0",
      "vspace": "0",
      "border": "0",
      "alt": "Bet at Betanysports.eu"
    }
  })])
}]}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, _vm._l((_vm.picks), function(pick) {
    return _c('div', {
      key: pick.id,
      staticClass: "post"
    }, [_c('h3', [_vm._v(_vm._s(pick.title) + "'")]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(pick.date))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pick.content))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(pick.pick))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.side))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.price))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(pick.units))]), _vm._v("\n         \n        "), _c('b', [_vm._v("units")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "big-btn red",
      attrs: {
        "to": {
          path: '/admin/pick/' + pick.id
        }
      }
    }, [_vm._v("\n          Edit Pick\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "big-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(pick)
        }
      }
    }, [_vm._v("Delete Pick")])], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }]
  }, [_vm._v("\n        Sign Up For Free!\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }],
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n        Get access to our daily email picks and more!\n      ")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('fname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n          Please enter a first name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('lname')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n          Please enter a last name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter an email\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first("password")) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('validateNumber')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter the spam protection number (5)\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }],
    attrs: {
      "name": "formregister"
    }
  }, [_c('p', [_vm._v("\n          First Name:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fname),
      expression: "user.fname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "fname",
    attrs: {
      "type": "text",
      "name": "fname",
      "maxlength": "25",
      "data-vv-delay": "3000"
    },
    domProps: {
      "value": _vm._s(_vm.user.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Last Name:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lname),
      expression: "user.lname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "lname",
      "maxlength": "25",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Email:        \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Password:  \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:repeatpassword'),
      expression: "'required|confirmed:repeatpassword'"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Repeat PW\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "label_name",
      "type": "password",
      "name": "repeatpassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          2 + 3 =      \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.validateNumber),
      expression: "user.validateNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^5$/
      }),
      expression: "{ required: true, regex: /^5$/ }"
    }],
    attrs: {
      "placeholder": "5",
      "type": "number",
      "name": "validateNumber",
      "maxlength": "1",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.validateNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.validateNumber = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "type": "submit",
      "value": "Register",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.registered),
      expression: "registered"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('h3', [_vm._v("Purchase a Premium Membership")]), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('h5', {
      key: p.id
    }, [_vm._v("\n            " + _vm._s(p.name) + "\n            "), _c('purchase-button', {
      attrs: {
        "package": p
      }
    })], 1)
  })], 2)])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-box"
  }, [_vm._v("\n          Thanks for signing up, you have been registered! Please\n          "), _c('a', {
    attrs: {
      "id": "success-login",
      "href": "#login-box"
    }
  }, [_vm._v("Log In.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Membership Benefits")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Register for Free to Get Our Daily Email Pick")]), _vm._v(" "), _c('li', [_vm._v("Ability to View Free Picks")]), _vm._v(" "), _c('li', [_vm._v("Access to Powerful Handicapping Information")]), _vm._v(" "), _c('li', [_vm._v("Expert Analysis")]), _vm._v(" "), _c('li', [_vm._v("Quality Picks")]), _vm._v(" "), _c('li', [_vm._v("Excellent Customer Service")]), _vm._v(" "), _c('li', [_vm._v("Information is never disclosed or shared, ever!")])])])])])])
}]}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        Consider our All Sports Packages for your one stop shop sports betting\n        needs. We offer expertise in College football picks, NFL football\n        picks, college basketball picks, college football predictions, Free\n        basketball picks, MLB Picks, sports betting advice, free football\n        picks.\n      ")]), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('h5', {
      key: p.id
    }, [_vm._v("\n        " + _vm._s(p.name) + "\n        "), _c('purchase-button', {
      attrs: {
        "package": p,
        "full-width": "true"
      }
    })], 1)
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 2), _vm._v(" "), _c('sidebar', {
    attrs: {
      "packages": _vm.packages
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "50%",
      "float": "left",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("\n          Membership Summary:\n        ")]), _vm._v(" "), _c('ul', [_c('h3', [_vm._v(_vm._s(_vm.dataPackage.name))]), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.dataPackage.description))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v("Price:")]), _vm._v(" $" + _vm._s(_vm.dataPackage.current_price))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "auto",
      "width": "50%",
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.purchaseDisabled
    },
    on: {
      "click": function($event) {
        _vm.debouncedClick()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('small', [_c('p', [_c('b', [_vm._v("Disclaimer:")]), _vm._v(" All sales are final. Previous results do not indicate future performance. No refunds will be issued.\n            By purchasing a membership, you agree to the terms and conditions\n            outlined in the\n            "), _c('router-link', {
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("terms of service")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        path: '/disclaimer'
      }
    }
  }, [_vm._v(" disclaimer")]), _vm._v(".\n          ")], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Full Access to Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Pick Notifications to Text/Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Access Unit Based Bankroll Strategy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('p', [_c('b', [_vm._v("Payment:")]), _vm._v(" Payment is processed securely through PayPal/Braintree.\n            Payment information is not accessible or stored by us in any form. We never have access to your payment details.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('p', [_c('b', [_vm._v("One Time Payment:")]), _vm._v(" Memberships are one time payments. We will never charge your account.\n            When your membership expires, you will need to purchase a new membership to continue receiving premium content. This is not a subscription.\n          ")])])
}]}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Package")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Sport:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sport),
      expression: "sport"
    }],
    on: {
      "change": function($event) {
        _vm.sport = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.sports), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": s
      }
    }, [_vm._v("\n                  " + _vm._s(s.sport) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Name:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pack.name),
      expression: "pack.name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "size": "33",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.pack.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pack.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Current Price:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pack.current_price),
      expression: "pack.current_price"
    }],
    attrs: {
      "type": "text",
      "name": "current_price",
      "size": "10",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.pack.current_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pack.current_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Sale:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pack.sale),
      expression: "pack.sale"
    }],
    attrs: {
      "type": "text",
      "name": "sale"
    },
    domProps: {
      "value": _vm._s(_vm.pack.sale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pack.sale = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Previous Price:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pack.previous_price),
      expression: "pack.previous_price"
    }],
    attrs: {
      "type": "text",
      "name": "previous_price"
    },
    domProps: {
      "value": _vm._s(_vm.pack.previous_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pack.previous_price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Save"
    }
  })])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('div', {
    staticClass: "success-box"
  }, [_c('div', {
    staticClass: "sprite success",
    staticStyle: {
      "display": "inline-block",
      "float": "left"
    }
  }), _vm._v(" Thank you for your purchase!\n      ")]), _vm._v(" "), _c('p')])])])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "footer-colums"
    }
  }, [_c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Company")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n                FAQ\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n                Contact Us\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/disclaimer'
      }
    }
  }, [_vm._v("\n                Disclaimer\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/privacy'
      }
    }
  }, [_vm._v("\n                Privacy Policy\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("\n                Terms of Use\n              ")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Contact Methods")]), _vm._v(" "), _c('ul', [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n                Email\n              ")])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-colum no-margin"
  }, [_c('h4', [_vm._v("From The Blog")]), _vm._v(" "), _c('ul', _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: post.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/blog'
        }
      }
    }, [_vm._v("\n                " + _vm._s(post) + "\n              ")])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottom-footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "alignleft"
  }, [_vm._v("\n          © Copyright 2009-" + _vm._s(_vm.year) + " StumptheSpread.com. All rights\n          reserved.\n        ")]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('login')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-colum"
  }, [_c('h4', [_vm._v("Get Social with Us")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://twitter.com/#!/StumpTheSpread",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ",
      "target": "_blank"
    }
  }, [_vm._v("Youtube")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://stumpthespread.com/register"
    }
  }, [_vm._v("Mailing List")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:support@stumpthespread.com"
    }
  }, [_vm._v("support@stumpthespread.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "alignright",
    attrs: {
      "id": "social-list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://stumpthespread.com/maillst/?p=subscribe&id=1",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Monthly Newsletter"
    }
  }, [_c('div', {
    staticClass: "sprite email"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://twitter.com/#!/StumpTheSpread",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Twitter"
    }
  }, [_c('div', {
    staticClass: "sprite twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ",
      "target": "_blank",
      "rel": "tipsy",
      "title": "Youtube"
    }
  }, [_c('div', {
    staticClass: "sprite youtube"
  })])])])
}]}

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toastr__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_breadcrumbs__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);

















__webpack_require__(232);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.component("vue-toastr", __WEBPACK_IMPORTED_MODULE_10_vue_toastr___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_8__routes__["a" /* routes */],
  mode: "history",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

__WEBPACK_IMPORTED_MODULE_14_axios___default.a.interceptors.response.use(function (response) {
  if (response.headers["x-token"] && response.config.url.indexOf("api/v1") > 0) {
    localStorage.setItem("sts_token", response.headers["x-token"]);
  }
  return response;
}, function (error) {
  if (error.response.status === 401 || error.response.data.error === "token_expired") {
    __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* store */].dispatch("logout");
    router.push("/");
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_11_vee_validate___default.a.Validator.extend("american_odds", {
  getMessage: function getMessage(field) {
    return field + " must be a valid American odds format (e.g., +150 or -200)";
  },
  validate: function validate(value) {
    return (/^[-+]?([1-9]\d{0,2}|1000)$/.test(value)
    );
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue2_breadcrumbs___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_meta___default.a, {
  keyName: "metaInfo"
});
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_analytics___default.a, {
  id: "UA-36581750-1",
  router: router
});
__WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.config("https://65d2bc6e5d6449f48b8aa0894f816737@sentry.io/185847", {
  release: "1.0.0",
  ignoreErrors: [/Validation Failed/, /Detected close during init/, "xcomponent", "adsbygoogle", "null is not an object (evaluating 'a.postMessage')", "No response from window", /Window closed for postrobot_method before ack/, "show_ads", "pagead", "Can not render button in IE intranet mode", "Out of memory", "postrobot_message_ack postrobot_ready error", "googleads.g.doubleclick.net"],
  ignoreUrls: [/localhost/, /googlesyndication\.com/]
}).addPlugin(__WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_2_vue___default.a).install();

new __WEBPACK_IMPORTED_MODULE_2_vue___default.a(__WEBPACK_IMPORTED_MODULE_2_vue___default.a.util.extend({ router: router, store: __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* store */] }, __WEBPACK_IMPORTED_MODULE_3__App___default.a)).$mount("#app");

/***/ })
],[533]);


// WEBPACK FOOTER //
// static/js/app.f126ad7470d69e849770.js